export default {
  certifications: {
    title: "Acreditaciones",
    text: "NED College se enorgullece de asociarse con instituciones líderes para garantizar el alto estándar de calidad que buscan nuestros estudiantes.",
  },
  studywithus: {
    header: {
      title: `<span class="text-green">Estudia inglés y trabaja</span>
         <span class="text-white"> en Irlanda con NED College</span>`,
      subtitle: `¡Da el primer paso ahora!`,
    },
    form: {
      title: "¡Da el primer paso ahora!",
      name: `Su nombre completo`,
      email: `Su correo electrónico`,
      whatsapp: `Tu WhatsApp`,
      nationality: `Por favor seleccione su nacionalidad`,
      campus: `¿En qué campus quieres estudiar?`,
      button: `¡Obtenga una cotización!`,
    },
    section1: {
      title: `¿Por qué elegir Irlanda para hacer tu intercambio?`,
      items: [
        "Oportunidad de <b>estudiar y trabajar</b> legalmente",
        "Uno de los <b>salarios mínimos</b> más altos de Europa",
        "<b>Facilidad en el proceso de obtención de visa,</b> realizado directamente en Irlanda después de tu llegada",
        "Oportunidad de <b>viajar a diversos países</b> por Europa",
      ],
    },
    section2: {
      title: `<span class="text-green">Con más de 10 años en el mercado,</span>, <span class="text-blue5">NED College</span> es una escuela de inglés en Irlanda que recibe a intercambistas de <span class="text-blue5">más de 30 nacionalidades diferentes</span>`,
      subtitle: `Con dos campus en el país, proporcionamos una experiencia extraordinaria para nuestros estudiantes y ofrecemos una enseñanza de excelencia académica`,
      button: "Quiero estudiar en NED College",
    },
    section3: {
      dublin: {
        title: "Campus de Dublín",
        subtitle:
          "Localizada en el corazón de la ciudad, con fácil acceso mediante transporte público, en dos edificios históricos construidos en 1750.",
        button: "Quiero estudiar en Dublin",
      },
      limerick: {
        title: "Campus de Limerick",
        subtitle:
          "Localizado en el centro de Limerick, con fácil acceso a pie a los principales puntos turísticos de la ciudad, en un edificio que ofrece instalaciones modernas y accesibilidad.",
        button: "Quiero estudiar en Limerick",
      },
    },
    section4: {
      title: "¿Por qué elegir NED College para hacer un intercambio en Irlanda?",
      items: [
        {
          img: "/landings/landing_0823/imgs/services_01.png",
          text: "<b>Kit de bienvenida</b>, reunión y tour de orientación",
        },
        {
          img: "/landings/landing_0823/imgs/services_02.png",
          text: "<b>Inmersión</b> Cultural",
        },
        {
          img: "/landings/landing_0823/imgs/services_03.png",
          text: "Asesoramiento <b>en tu propio idioma</b>",
        },
        {
          img: "/landings/landing_0823/imgs/services_04.png",
          text: "Actividades <b>y viajes</b>",
        },
        {
          img: "/landings/landing_0823/imgs/services_05.jpeg",
          text: "Profesores <b>Cualificados</b>",
        },
        {
          img: "/landings/landing_0823/imgs/services_06.jpeg",
          text: "Clases <b>extracurriculares</b>",
          description: "(Conversación, Pronunciación, etc.)",
        },
        {
          img: "/landings/landing_0823/imgs/services_07.jpeg",
          text: "<b>Talleres</b> y cursos de formación profesional",
        },
        {
          img: "/landings/landing_0823/imgs/services_08.jpeg",
          text: "<b>Apoyo al estudiante</b> en Irlanda",
        },
        {
          img: "/landings/landing_0823/imgs/services_09.jpeg",
          text: "<b>Flexibilidad</b> en el pago",
        },
        {
          img: "/landings/landing_0823/imgs/services_10.png",
          text: "<b>App exclusiva</b> de NED College",
        },
        {
          img: "/landings/landing_0823/imgs/services_11.png",
          text: "Descuentos en <b>empresas asociadas</b>",
        },
      ],
      button: "Quiero estudiar en NED College",
    },
    section5: {
      title: "¿Qué dicen nuestros alumnos?",
      button: "¡Obtén una cotización!",
    },
    section6: {
      button: "Quiero estudiar en NED College",
    },
  },
  studywithus_thanks: {
    title: `¡Gracias por su interés en <span class="text-green">NED College!</span>`,
    subtitle: `Hemos recibido sus datos y <span class="text-green2">nos pondremos en contacto en breve.</span>`,
    description: `Ahora que has dado el primer paso, <span class="text-blue2">aprovecha la oportunidad para descubrir más sobre nuestra
       Escuela de inglés</span> y explora cómo es la vida como estudiante de intercambio con NED College.`,
    socials_title: "Sigue nuestras redes sociales",
  },

  home: {
    header: {
      title1: "Estudia inglés en Irlanda",
      title2: "con NED College",
      subtitle: "¡Cursos de inglés hechos para ti!",
    },
    section1: {
      title1: "Un nuevo viaje está por comenzar",
      title2:
        "Fundada en 2011, esta Escuela de Inglés tiene dos campus en Irlanda: Dublín y Limerick",
      title3:
        "Nos sentimos verdaderamente honrados de decir que hemos ayudado a más de 13.000 estudiantes de 33 naciones diferentes de todo el mundo a aprender inglés, mientras tienen increíbles experiencias en Irlanda.",
      button: "Quiero empezar mi nuevo viaje",
    },
    splitted_section: {
      title1: "Campus de Dublín",
      text1:
        "La escuela está ubicada en el corazón de la ciudad, accesible a través de múltiples servicios de transporte público o a pie, dentro de dos hermosos edificios históricos construidos en 1750.",
      button1: "Quiero saber más",
      title2: "Campus de Limerick",
      text2:
        "Nuestro segundo campus también está ubicado en el corazón de la ciudad en Limerick, en un hermoso y moderno edificio, ¡con instalaciones completamente nuevas y modernas!",
      button2: "Quiero saber más",
    },
    section_courses: {
      title: "Descubre nuestros cursos de inglés",
      text: "¡Elige el curso que más te convenga y comienza tu viaje con nosotros!",
      button: "Descubrir todos los cursos",
      first_card_title: "Curso de inglés a largo plazo",
      first_card_text:
        "¡El curso más amado y elegido por los estudiantes! Este programa te dará la oportunidad de obtener una visa que te permitirá estudiar y trabajar legalmente durante 8 meses.",
      second_card_title: "Curso de inglés a corto plazo",
      second_card_text:
        "Ideal para estudiantes que desean mejorar y practicar el idioma en un entorno perfecto en poco tiempo.",
      third_card_title: "Inglés general + IELTS",
      third_card_text:
        "Curso de preparación para el examen IELTS. El Sistema Internacional de Pruebas de Idioma Inglés (IELTS) está diseñado para ayudarte a trabajar, estudiar o emigrar a un país donde el inglés es el idioma nativo.",
    },
    studentlife: {
      title: "Vida de estudiante",
      text: "¡Nuestra escuela ofrece mucho más que cursos de inglés, ofrecemos toda una experiencia!",
      activities1: "Actividades y excursiones",
      activities2: "y",
      activities3: "Clases extracurriculares",
      app: "Aplicación exclusiva",
      app2: "para estudiantes de NED College",
      accomodation1: "Alojamiento temporal",
      accomodation2: " en Irlanda",
      airport1: "Recogida en el",
      airport2: "aeropuerto",
      button: "Más sobre nuestros servicios",
    },
    modal: {
      image: "",
      imageMobile: "/imgs/st-patricks-discount-mobile.png",
    },
  },
  ned_college: {
    title: "<span class='text-green2'>Escuela de inglés</span> en Irlanda",
    breadcr: ["Sobre Nosotros", ">", "NED College"],
    section1: {
      title1: "NED College es una escuela de inglés",
      title2: " con sede en Irlanda",
      text1:
        "Desde 2011, hemos estado ayudando a estudiantes de todo el mundo a mejorar su inglés, conectarse con nuevas personas y un nuevo mundo, ofreciendo la mejor calidad de aprendizaje mientras tienen una experiencia increíble en Irlanda.",
      text2:
        "Durante más de 10 años, nuestro equipo ha estado trabajando arduamente para brindar lo mejor para nuestros estudiantes, ofreciéndoles mucho más que solo clases de inglés: ¡una EXPERIENCIA INOLVIDABLE!",
      text3:
        "Actualmente, NED College tiene dos campus en el país; uno en Dublín y otro en Limerick, y en cada uno de ellos encontrarás las instalaciones ideales para asegurarte de tener la mejor experiencia educativa en el extranjero.",
    },
    section2: {
      title: "Dando la bienvenida a estudiantes de todo el mundo",
      text: "Un entorno multicultural, con personas, culturas y antecedentes diferentes, es la mejor manera de aprender/mejorar un nuevo idioma. En NED College, hemos estado invirtiendo en este principio desde 2010. Hemos ayudado a más de 12 mil estudiantes de más de 30 países a mejorar su inglés, y disfrutar de una experiencia que nunca olvidarán.",
    },
    section3: {
      title1: "Si estudiar en el extranjero siempre ha sido uno de tus sueños,",
      title2: "¡estás en el lugar adecuado para hacerlo realidad!",
      button: "Quiero vivir mi sueño",
    },
    section4: {
      title: "¿Por qué elegir NED College?",
      text1: "+10 años en el campo de la educación",
      text2: "Apoyo a los estudiantes en tu propio idioma",
      text3: "+12.000 personas han estudiado con nosotros",
      text4: "Más de 33 nacionalidades",
      text5: "Dos campus: Dublín y Limerick",
      text6: "Profesores titulados",
      button: "¡Comienza tu viaje en Irlanda con NED College!",
    },
    section5: {
      title:
        "Todos nuestros profesores tienen al menos un título universitario y una cualificación reconocida en la enseñanza del inglés.",
      text: "Todos nuestros profesores son profesionales. Muchos han enseñado no solo en Irlanda sino también en el extranjero y aportan una gran experiencia al aula para asegurarse de que tu tiempo con nosotros sea educativo, interesante y divertido.",
    },
    section6: {
      title1: "Campus de Dublín",
      text1:
        "Ubicado en el corazón de la ciudad, dentro de dos hermosos edificios históricos construidos en 1750. ¡Esta ubicación ha sido el hogar de NED College durante más de 10 años!",
      button1: "¡Elijo Dublín!",
      circle1: "Elegir",
      circle2: "entre",
      title2: "Campus de Limerick",
      text2:
        "Nuestro segundo campus está ubicado en el corazón de la ciudad de Limerick, en un hermoso edificio, con instalaciones completamente nuevas y modernas!",
      button2: "¡Elijo Limerick!",
    },
    section7: {
      title: "Misión, Ética y Valores de NED College",
      subtitle:
        "La alta dirección y los directores de la empresa han redefinido nuestra declaración de misión después de un período de consulta para reflejar mejor nuestros valores.",
      subtitle1: "Declaración de Misión",
      text1:
        "Nuestra misión es ser la primera opción de los estudiantes de inglés al proporcionar una experiencia de aprendizaje de alta calidad y excelencia en la enseñanza de idiomas. Nuestro personal trabaja en colaboración, donde las necesidades de nuestros estudiantes, que están en el centro de nuestras acciones diarias, son para el desarrollo de la comunidad de NED College en su conjunto.",
      text2:
        "Nos esforzamos por ofrecer un enfoque de la educación en el idioma inglés que refleje y atienda las necesidades de nuestra diversa comunidad estudiantil, creando un entorno de aprendizaje positivo y divertido, respaldado por las mejores prácticas, que sea inclusivo y de apoyo, asegurando que nuestros estudiantes alcancen sus objetivos académicos.",
      subtitle2: "Ética",
      text3:
        "La ética de NED College se basa en nuestros valores fundamentales de comunidad, individualidad, solidaridad grupal, diversidad, excelencia en la enseñanza y respeto por todos. Nuestro personal trabaja en colaboración para establecer una relación con cada estudiante, desarrollando un sentido de individualidad y solidaridad dentro de nuestra comunidad del College dentro y fuera del aula.",
      text4:
        "Brindamos capacitación y desarrollo centrados para garantizar que ofrezcamos excelencia en la enseñanza, cumpliendo con la legislación y los estándares requeridos, de acuerdo con las mejores prácticas de la industria. Creemos en tratar a todos de manera justa y ética, y esto se refleja en nuestro logotipo de ética.",
      subtitle3: "Con este fin, NED College se compromete a:",
      list1: "Promover la igualdad para todos los estudiantes",
      list2: "Evaluar a los estudiantes de manera justa y consistente",
      list3:
        "Brindar oportunidades para recibir comentarios y resolver cualquier problema de manera profesional y oportuna",
      list4:
        "Cumplir con las pautas y obligaciones legislativas aplicables e implementar recomendaciones y directivas que se avecinen.",
    },
    section8: {
      text1:
        "NED College brinda una experiencia culturalmente inmersiva donde se brinda apoyo a los estudiantes en todos los niveles,",
      text2:
        "abrazando la diversidad y ayudando a los estudiantes a integrarse en la sociedad irlandesa para aprovechar al máximo su experiencia de aprendizaje.",
    },
    testimonial: {
      title: "Mira lo que dicen nuestros estudiantes sobre NED College",
    },
  },
  courses: {
    title: "Cursos de inglés en Irlanda",
    breadcr: ["Cursos"],
    section1: {
      title1: "Maximiza tu potencial con nuestros Cursos de Inglés para adultos",
      subtitle1:
        "En NED College queremos brindarte la mejor oportunidad posible, ya sea que estés aprendiendo para avanzar en tu carrera, desarrollar tus habilidades personales o viajar con confianza.",
      title2: "Cursos de Inglés General",
      text1: "Si quieres vivir una nueva",
      text2: "experiencia cultural",
      text3:
        "y alcanzar el mejor nivel posible con clases intensivas, ¡este curso es para ti! Todas las",
      text4: "clases para adultos",
      text5: "se imparten 5 días a la semana, de lunes a viernes, con los",
      text6: "mejores profesores de inglés con experiencia",
      cards: [
        {
          color: "blue2",
          tag: "25 semanas",
          title: "Curso de Inglés General a Largo Plazo",
          bodyTitle: "",
          body: "\n          Lleva tus habilidades en inglés al siguiente nivel y disfruta de esta experiencia con nosotros. Para llevar a cabo este curso, la mayoría de los viajeros necesitan solicitar una Visa de Estudiante, que les permite trabajar y estudiar legalmente en Irlanda mientras están aquí. Además, los estudiantes pueden presentar exámenes de certificación al final de su curso, como los exámenes TIE, IELTS, Cambridge y Trinity.\n          ",
          image: null,
          button: "¡Quiero un presupuesto!",
        },
        {
          color: "blue3",
          tag: "4, 8 y 12 semanas",
          title: "Curso de Inglés General a Corto Plazo",
          bodyTitle: "",
          body: "\n          Ideal para estudiantes que desean mejorar y practicar el idioma en un entorno perfecto en poco tiempo.\n          ",
          image: null,
          button: "¡Quiero un presupuesto!",
        },
        {
          color: "green2",
          tag: "4, 8 y 12 semanas",
          title: "Programa de Inglés General para el Invierno",
          bodyTitle: "Octubre, Noviembre, Enero y Febrero",
          body: "\n          Este programa es recomendado para aquellos que no pueden pasar un período largo en Irlanda y desean mejorar sus habilidades en inglés y disfrutar del tiempo en Irlanda.\n          ",
          image: null,
          button: "¡Quiero un presupuesto!",
        },
        {
          color: "green1",
          tag: "4, 8 y 12 semanas",
          title: "Programa de Inglés General para el Verano",
          bodyTitle: "Junio, Julio y Agosto",
          body: "\n          Este programa es recomendado para aquellos que no pueden pasar un período largo en Irlanda y desean mejorar sus habilidades en inglés y disfrutar el verano en Irlanda.\n          ",
          image: null,
          button: "¡Quiero un presupuesto!",
        },
        {
          color: "red",
          tag: "25 semanas",
          title: "Curso de Inglés General + Preparación para el IELTS",
          bodyTitle: "",
          body: "\n          El Sistema Internacional de Pruebas del Idioma Inglés (IELTS) está diseñado para ayudarte a trabajar, estudiar o emigrar a un país donde el inglés es el idioma nativo.\n          ",
          image: "logo_ielts",
          button: "¡Quiero un presupuesto!",
        },
      ],
    },
    section2: {
      title: "Quienes tienen un buen nivel de habilidad",
      text1:
        "NED College tiene cursos disponibles para todos los niveles de inglés, desde estudiantes que tienen poco o ningún conocimiento del idioma, hasta aquellos que tienen un buen nivel pero desean seguir mejorándolo. A la derecha, puedes encontrar una lista de los diferentes niveles y el tipo de examen de certificado que te recomendamos realizar al final de tu curso.",
      text2: "Nivel",
      text3: "Tipo de examen (recomendado)",
      accordion_data: {
        0: {
          title: "A0 - A1 | Principiante",
          tag: "TIE",
          body: [
            {
              type: "p",
              class: "fw-bold text-blue2",
              text: "Esquema del curso y objetivos",
            },
            {
              type: "p",
              class: "",
              text: "El curso de inglés general Pre A1 está dirigido a estudiantes con muy poco o ningún conocimiento o experiencia del idioma inglés para comenzar a desarrollar las cuatro habilidades: lectura, escritura, hablar y escuchar. Este curso está diseñado para desarrollar habilidades básicas en inglés y construir confianza para interactuar con interlocutores nativos y no nativos en el idioma objetivo sobre una variedad de temas familiares utilizando vocabulario cotidiano y estructuras gramaticales simples. Es el primer paso hacia la eficiencia comunicativa. En última instancia, el objetivo del curso A0 es que los estudiantes avancen al curso A1 donde podrán desarrollar y consolidar aún más sus habilidades en el idioma y en ese nivel podrán presentar un examen externo. Durante un período de once semanas, se espera que los estudiantes cubran las áreas del idioma y cumplan con los resultados enumerados a continuación:",
            },
            {
              type: "p",
              class: "fw-bold text-green1",
              text: "Se asignan las siguientes competencias al curso Pre A1, al final del cual los estudiantes podrán demostrar las siguientes habilidades:",
            },
            {
              type: "p",
              class: "fw-bold text-green1",
              text: "Habilidades receptivas",
            },
            {
              type: "ul",
              list: [
                "Interactuar de manera simple siempre y cuando la otra persona esté dispuesta a repetir o reformular las cosas a una velocidad de habla más lenta y ayudar con la formulación.",
                "Comprender la idea general de textos informativos simples y descripciones breves y simples, especialmente si contienen imágenes que ayudan a explicar el texto.",
                "Comprender textos breves y simples, uniendo nombres, palabras y frases básicas conocidas, por ejemplo, volviendo a leer partes del texto.",
                "Comprender mensajes cortos y simples, por ejemplo, en tarjetas postales.",
                "Comprender expresiones cotidianas relacionadas con necesidades cotidianas simples y concretas, en un discurso claro, lento y repetido.",
                "Comprender preguntas e instrucciones y seguir indicaciones cortas y simples.",
                "Comprender números, precios y horarios.",
                "Seguir instrucciones escritas cortas y simples, especialmente si contienen imágenes.",
                "Reconocer nombres, palabras y frases muy básicas conocidas en carteles simples en el aula y alrededor de la escuela.",
                "Entender un discurso que es muy lento y claramente articulado, con pausas largas para entender el significado",
              ],
            },
            {
              type: "p",
              class: "fw-bold text-green1",
              text: "Habilidades productivas",
            },
            {
              type: "ul",
              list: [
                "Usar frases y oraciones simples para describir dónde vive y las personas que conoce.",
                "Hacer y responder preguntas simples en áreas de necesidad inmediata o sobre temas muy familiares.",
                "Establecer un contacto social básico utilizando las formas más simples de cortesía cotidiana: saludos y despedidas; presentaciones; decir por favor, gracias, perdón, etc.",
                "Escribir un mensaje o postal corta y simple, por ejemplo, para enviar saludos de vacaciones.",
                "Completar formularios con detalles personales, por ejemplo, ingresar nombre, nacionalidad y dirección en un formulario de registro de hotel.",
                "Escribir frases y oraciones simples y pueden escribir una postal simple. Pueden escribir cartas y mensajes cortos con la ayuda de un diccionario.",
              ],
            },
          ],
          footer: [
            {
              type: "p",
              class: "fw-bold text-blue2",
              text: "Preparación para el examen",
            },
            {
              type: "p",
              class: "",
              text: "No hay un examen de salida asociado con el nivel Pre A1. No se espera que los estudiantes pasen más de 11 semanas en este nivel. Al avanzar hacia el nivel A1 serán elegibles para el Test of Interactive English.",
            },
          ],
        },
        1: {
          title: "A1 - A2 | Elemental",
          tag: "TIE",
          body: [
            {
              type: "p",
              class: "text-blue2",
              text: "Esquema del curso y objetivos",
            },
            {
              type: "p",
              class: "",
              text: "El curso de Inglés General A1 está dirigido a estudiantes que acuden a NED C con una familiaridad básica con el inglés, y que pueden haber tenido alguna experiencia informal de aprendizaje del inglés y contacto con el idioma ya sea en un entorno educativo, social o recreativo. Este podría no ser el primer curso de estudio reciente de un alumno. Sin embargo, como se menciona anteriormente, cada curso está estructurado para permitir que un estudiante permanezca en el nivel designado durante el tiempo que sea necesario, hasta una duración de 25 semanas. Durante el período de veinticinco semanas, se espera que los estudiantes cubran las áreas del lenguaje a continuación:",
            },
            {
              type: "p",
              class: "text-green1",
              text: "Los siguientes resultados de aprendizaje se asignan al curso A1 (elemental), al final del cual los estudiantes podrán:",
            },
            {
              type: "p",
              class: "text-green1",
              text: "Habilidades receptivas",
            },
            {
              type: "ul",
              list: [
                "Comprender el habla clara, lenta y estándar relacionada con áreas de relevancia personal más inmediata (por ejemplo, información personal y familiar muy básica, compras, geografía local y empleo).",
                "Captar el punto principal en mensajes y anuncios breves, claros y simples.",
                "Comprender textos cortos y simples que contengan vocabulario de alta frecuencia y expresiones internacionales compartidas.",
                "Encontrar información específica y previsible en materiales cotidianos simples como anuncios, prospectos y horarios.",
                "Comprender letreros y avisos cotidianos en lugares públicos, como calles, restaurantes, estaciones de tren y lugares de trabajo.",
              ],
            },
            {
              type: "p",
              class: "text-green1",
              text: "Habilidades productivas",
            },
            {
              type: "ul",
              list: [
                "Comunicarse en tareas simples y rutinarias que requieran un intercambio de información simple y directo sobre temas y actividades familiares.",
                "Manejar intercambios sociales muy breves, aunque normalmente no puedan mantener la conversación por sí mismos.",
                "Tener suficiente vocabulario para expresar necesidades comunicativas básicas y para enfrentar necesidades de supervivencia simples.",
                "Usar algunas estructuras simples correctamente, pero aún cometer errores básicos sistemáticamente, como la confusión de tiempos verbales y olvidarse de marcar acuerdos.",
                "Dar descripciones breves y básicas de eventos y actividades, y poder escribir cartas personales muy simples expresando agradecimiento y disculpa.",
                "Escribir notas y mensajes cortos y simples relacionados con asuntos de la vida cotidiana.",
                "Describir planes y arreglos, y poder explicar lo que les gusta o no les gusta de algo.",
                "Describir a su familia, condiciones de vida, educación, trabajo actual o más reciente, y poder describir actividades pasadas y experiencias personales.",
              ],
            },
            {
              type: "p",
              class: "fw-bold text-blue2",
              text: "Preparación para el examen",
            },
            {
              type: "p",
              class: "",
              text: "El examen al final de este nivel, para los estudiantes que terminan su curso de aprendizaje en el nivel A1 o han avanzado y no han completado el número suficiente de semanas en el nivel A2, es el Test de Inglés Interactivo (TIE). Se ofrecen clases de apoyo y clases adicionales a aquellos estudiantes a los que les corresponda. No hay contenido de examen específico en este plan de estudios para este examen. Sin embargo, los componentes del examen se basan en habilidades adquiridas a través de la aplicación del programa establecido de 25 semanas en las áreas de lectura, escritura, expresión oral y comprensión auditiva. El coordinador de exámenes de NED C será responsable de ofrecer apoyo individual o en grupos pequeños a aquellos estudiantes en el nivel A1 que se presenten a este examen.",
            },
          ],
        },
        2: {
          title: "A2 - B1 | Pre-Intermedio",
          tag: "TIE o Trinity ISE Foundation",
          body: [
            {
              type: "p",
              class: "fw-bold text-blue2",
              text: "Esquema del curso y objetivos",
            },
            {
              type: "p",
              class: "",
              text: "Nivel de inglés general A2 (Pre-intermedio) Esquema del curso y objetivos El curso de inglés general A2 es para estudiantes que han comenzado a consolidar su comprensión de habilidades elementales en inglés pero aún no muestran la gama de competencias, en todas las áreas de habilidades, que los llevarían a sentirse cómodos o seguros en nivel intermedio. Los estudiantes pueden interactuar de manera sencilla, pero trabajarán para ampliar su rango de estructuras gramaticales y vocabulario para el uso diario en una variedad de contextos, promoción personal y confianza. Durante un período de veinticinco semanas, se espera que los estudiantes cubran las siguientes áreas del idioma:",
            },
            {
              type: "p",
              class: "fw-bold text-green1",
              text: "Los siguientes resultados de aprendizaje están asignados al curso A2 (Pre-intermedio), al final del cual los estudiantes serán capaces de:",
            },
            {
              type: "p",
              class: "fw-bold text-green1",
              text: "Habilidades Receptivas",
            },
            {
              type: "ul",
              list: [
                "Utilizar estructuras ligeramente más complejas que en el nivel elemental de manera correcta, pero aún cometer errores básicos de forma sistemática, como confusión de tiempos verbales y olvido de marcar acuerdos.",
                "Comprender un discurso claro, lento y estándar relacionado con áreas de mayor relevancia personal inmediata (por ejemplo, información personal y familiar muy básica, compras, geografía local y empleo).",
                "Captar la idea principal en mensajes y anuncios cortos, claros y simples.",
                "Comprender textos cortos y simples que contienen vocabulario de alta frecuencia y expresiones internacionales compartidas.",
                "Encontrar información específica y predecible en material cotidiano y simple, como anuncios, prospectos y horarios.",
                "Comprender los letreros y avisos cotidianos en lugares públicos, como calles, restaurantes, estaciones de tren y lugares de trabajo.",
              ],
            },
            {
              type: "p",
              class: "fw-bold text-green1",
              text: "Habilidades Productivas",
            },
            {
              type: "ul",
              list: [
                "Comunicarse en tareas simples y rutinarias que requieren un intercambio directo y sencillo de información sobre temas familiares y rutinarios.",
                "Describir en términos simples aspectos de su entorno inmediato y asuntos en áreas de necesidad inmediata.",
                "Manejar intercambios sociales breves y poder extender la conversación por sí mismos (a través del uso de etiquetas de pregunta/preguntas de seguimiento).",
                "Tener un vocabulario suficiente para llevar a cabo tareas cotidianas en el supermercado/banco, etc.",
                "Dar descripciones extendidas de eventos y actividades y poder escribir cartas personales muy simples para expresar agradecimientos, solicitudes y disculpas.",
                "Escribir notas y mensajes cortos y simples relacionados con asuntos de la vida cotidiana.",
                "Describir planes y arreglos y poder explicar lo que les gusta o no les gusta de algo.",
                "Describir su familia, condiciones de vida, educación, trabajo actual o más reciente y poder describir actividades pasadas y experiencias personales.",
              ],
            },
          ],
          footer: [
            {
              type: "p",
              class: "fw-bold text-blue2",
              text: "Preparación para el examen",
            },
            {
              type: "p",
              class: "",
              text: "En el nivel A2, el examen de salida designado es el Trinity English. En el programa de estudio para el nivel A2 se incluyen ejercicios de práctica del tipo que se espera en el examen. El contenido de inglés general del curso se considera suficiente para preparar a los estudiantes para el lenguaje necesario para aprobar el examen, pero se incluye práctica adicional en el programa de estudio para que los profesores familiaricen a los estudiantes con la forma del examen. El coordinador del examen NED C ofrecerá un apoyo adicional y discreto.",
            },
          ],
        },
        3: {
          title: "B1 - B2 | Intermedio",
          tag: "B1 Preliminar",
          body: [
            {
              type: "p",
              class: "fw-bold text-blue2",
              text: "Programa del curso y objetivos",
            },
            {
              type: "p",
              class: "",
              text: "El curso B1 está dirigido a estudiantes que han comenzado a consolidar e implementar su comprensión de las estructuras gramaticales del inglés y buscan desarrollar un vocabulario más amplio con énfasis en la pronunciación y la fluidez en el inglés oral y escrito. Durante un período de veinticinco semanas, se espera que los estudiantes cubran las siguientes áreas del lenguaje:",
            },
            {
              type: "p",
              class: "fw-bold text-green1",
              text: "Los siguientes resultados de aprendizaje están asignados al curso B1 (intermedio), al final del cual los estudiantes podrán:",
            },
            {
              type: "p",
              class: "fw-bold text-green1",
              text: "Habilidades de recepción",
            },
            {
              type: "ul",
              list: [
                "Comprender textos sencillos sobre temas relacionados con sus campos de interés",
                "Encontrar y comprender información general que necesitan en materiales cotidianos, como cartas, folletos y documentos oficiales breves",
                "Buscar uno o varios textos largos para localizar información específica que necesitan para ayudarles a completar una tarea",
                "Comprender los puntos principales de un discurso claro y estándar sobre temas familiares que se encuentran regularmente en el trabajo, la escuela, el tiempo libre, etc.",
                "Comprender el punto principal de muchos programas de radio o televisión sobre noticias actuales o temas de interés personal o profesional cuando la exposición es relativamente lenta y clara",
                "Adivinar el significado de palabras desconocidas ocasionales a partir del contexto y comprender el significado de las frases",
                "En general, seguir los puntos principales de una discusión extendida",
                "Seguir el habla clara en una conversación cotidiana, aunque en situaciones de la vida real a veces tendrán que pedir la repetición de palabras y frases particulares",
              ],
            },
            {
              type: "p",
              class: "fw-bold text-green1",
              text: "Habilidades productivas",
            },
            {
              type: "ul",
              list: [
                "Iniciar, mantener y finalizar conversaciones simples cara a cara sobre temas que son familiares o de interés personal",
                "Participar en conversaciones improvisadas sobre temas que son familiares, de interés personal o pertinentes para la vida cotidiana (por ejemplo, familia, pasatiempos, trabajo, viajes y eventos actuales)",
                "Usar los conectores más frecuentes para enlazar oraciones simples y contar una historia o describir algo",
                "Dar brevemente razones y explicaciones de opiniones y planes",
                "Narrar una historia o contar la trama de un libro o película y describir reacciones",
                "Escribir informes muy breves que transmitan información factual rutinaria y expliquen las razones de las acciones, escribir cartas personales que describan experiencias, sentimientos y eventos en detalle",
                "Describir detalles básicos de eventos imprevisibles, por ejemplo, un accidente",
              ],
            },
          ],
          footer: [
            {
              type: "p",
              class: "fw-bold text-blue2",
              text: "Preparación para el examen",
            },
            {
              type: "p",
              class: "",
              text: "En el nivel B1, el examen de salida designado es el Cambridge B1 Preliminary. Dentro del programa de estudios para el nivel B1 se incluyen selecciones de pruebas de práctica en las áreas de habilidad examinadas por Cambridge. Estas aparecen cada dos semanas en el programa de estudios. El curso en su conjunto contiene cuatro pruebas de práctica completas divididas en áreas de habilidad para un análisis más detallado. De esta manera, los profesores pueden familiarizar a los estudiantes con la naturaleza de las pruebas de lectura, escritura, escucha y expresión oral que tomarán al final de su curso. Se ofrecerán más pruebas de práctica y ejercicios a los estudiantes a medida que se acerquen al final de su curso, coordinado por el examinador de NED C.",
            },
          ],
        },
        4: {
          title: "B2 - C1 | Intermedio superior",
          tag: "B2 First o IELTS",
          body: [
            {
              type: "p",
              class: "fw-bold text-blue2",
              text: "Esquema del curso y objetivos",
            },
            {
              type: "p",
              class: "",
              text: "El curso de inglés general B2 es para estudiantes que tienen una buena eficiencia comunicativa y solidez en las cuatro áreas de habilidades, pero que necesitan mejorar en fluidez e implementación de estructuras gramaticales más complejas. Buscarán mejorar su comprensión de temas concretos y abstractos y producirán inglés hablado y escrito sobre una amplia gama de temas con mínima necesidad de corrección y aprobación de interlocutores nativos. Durante un período de veinticinco semanas, se espera que los estudiantes cubran las áreas de lenguaje siguientes:",
            },
            {
              type: "p",
              class: "fw-bold text-green1",
              text: "Los siguientes resultados de aprendizaje se asignan al curso B2 (intermedio superior), al final del cual los estudiantes podrán:",
            },
            {
              type: "p",
              class: "fw-bold text-green1",
              text: "Habilidades receptivas",
            },
            {
              type: "ul",
              list: [
                "Leer correspondencia relacionada con sus campos de interés y entender fácilmente el significado esencial.",
                "Entender artículos especializados fuera de su campo, siempre y cuando puedan utilizar un diccionario para confirmar la terminología.",
                "Leer diferentes tipos de textos con bastante facilidad a diferentes velocidades y de diferentes maneras según el propósito de su lectura y el tipo de texto.",
                "Tener un amplio vocabulario de lectura, pero a veces tener dificultades con palabras y frases menos comunes.",
                "Identificar rápidamente el contenido y la relevancia de noticias, artículos e informes sobre una amplia gama de temas profesionales, decidiendo si merece un estudio más detenido.",
                "Entender artículos e informes relacionados con problemas contemporáneos en los que los escritores adoptan posturas o puntos de vista particulares.",
                "Comprender el discurso estándar hablado a una velocidad normal y seguir incluso líneas de argumentación complejas siempre que el tema sea razonablemente familiar.",
                "Entender lo esencial de las conferencias y la mayoría de los programas de noticias y actualidad de la televisión y poder entender la mayoría de las películas en dialecto estándar.",
                "Comprender conceptos donde solo el ruido de fondo extremo, la estructura poco clara y/o el uso idiomático causen algunos problemas.",
              ],
            },
            {
              type: "p",
              class: "fw-bold text-green1",
              text: "Habilidades productivas",
            },
            {
              type: "ul",
              list: [
                "Interactuar con un grado de fluidez y espontaneidad que permite una interacción regular con hablantes nativos.",
                "Participar activamente en discusiones en contextos familiares y defender y sostener puntos de vista de manera clara proporcionando explicaciones y argumentos relevantes.",
                "Presentar descripciones claras y detalladas sobre una amplia gama de temas relacionados con su campo de interés, ampliando y apoyando las ideas con puntos secundarios y ejemplos relevantes.",
                "Explicar un punto de vista sobre un tema de actualidad y dar ventajas y desventajas de varias opciones.",
                "Escribir textos claros y detallados sobre una amplia gama de temas relacionados con sus intereses. Escribir un ensayo/ reseña/ artículo o informe, transmitiendo información o dando razones a favor o en contra de un punto de vista particular.",
                "Escribir cartas/correos electrónicos resaltando la importancia personal de eventos y experiencias.",
                "Sintetizar información y argumentos de diferentes fuentes.",
                "Construir una cadena de argumentación razonada y especular sobre causas, consecuencias y situaciones hipotéticas.",
              ],
            },
          ],
          footer: [
            {
              type: "p",
              class: "fw-bold text-blue2",
              text: "Preparación para el examen",
            },
            {
              type: "p",
              class: "",
              text: "En B2, el examen de salida designado es el Cambridge B2 First. El programa de 25 semanas está estructurado para proporcionar práctica y análisis de preguntas de examen Cambridge B2 First en contexto y dentro del marco de un curso de inglés general. Hay ocho semanas completas de ejercicios, actividades y práctica en estilo Cambridge, intercaladas a intervalos de tres semanas en el programa. La semana 25 del curso está dedicada exclusivamente al examen de Cambridge, con los estudiantes trabajando en ejemplos de exámenes anteriores. A lo largo del curso, los estudiantes se familiarizarán con el tipo de preguntas, actividades e idioma que se evaluarán. Esto constituye aproximadamente un tercio del contenido total de un curso general que se enfoca en la eficiencia y efectividad comunicativa. Se ofrecerán más ejercicios y ejemplos de práctica a medida que los estudiantes se acerquen al final de su curso, por parte del coordinador del examen NED C.",
            },
          ],
        },
        5: {
          title: "C1 - C2 | Avanzado",
          tag: "C1 Advanced o IELTS",
          body: [
            {
              type: "p",
              class: "fw-bold text-blue2",
              text: "Descripción del curso y objetivos",
            },
            {
              type: "p",
              class: "",
              text: "El curso de inglés general C1 es para estudiantes que tienen un sólido dominio de las estructuras gramaticales y pueden usar el inglés de manera flexible tanto escrito como hablado. Los estudiantes buscarán ampliar su vocabulario y comprensión del inglés tal como se utiliza en diferentes contextos educativos, profesionales y sociales para mejorar su eficiencia comunicativa con un mínimo de reparación y búsqueda de expresiones.",
            },
            {
              type: "p",
              class: "fw-bold text-green1",
              text: "Los siguientes resultados de aprendizaje se asignan al curso C1 (avanzado), al final del cual los estudiantes podrán:",
            },
            {
              type: "p",
              class: "fw-bold text-green1",
              text: "Habilidades receptivas",
            },
            {
              type: "ul",
              list: [
                "Comprender cualquier correspondencia con un uso ocasional del diccionario.",
                "Comprender en detalle instrucciones largas y complejas sobre una nueva máquina o procedimiento, incluso fuera de su propio campo de especialización si pueden volver a leer secciones difíciles.",
                "Mantenerse al día con una conversación animada entre hablantes nativos y entender lo suficiente como para seguir un discurso extendido sobre temas abstractos y complejos más allá de su propio campo.",
                "Reconocer una amplia gama de expresiones idiomáticas y coloquialismos y reconocer cambios de estilo.",
                "Seguir un discurso extendido incluso cuando no está claramente estructurado y cuando las relaciones entre ideas solo se implican y no se declaran explícitamente.",
                "Seguir la mayoría de las conferencias, discusiones y debates con relativa facilidad y poder extraer información específica de anuncios públicos de baja calidad.",
                "Comprender información técnica compleja, como instrucciones de funcionamiento, especificaciones de productos y servicios familiares.",
                "Comprender una amplia gama de material de audio grabado, incluido algún lenguaje no estándar, e identificar detalles y actitudes implícitas en las relaciones entre los hablantes.",
                "Seguir películas que contienen un considerable grado de argot y uso idiomático",
              ],
            },
            {
              type: "p",
              class: "fw-bold text-green1",
              text: "Habilidades productivas",
            },
            {
              type: "ul",
              list: [
                "Presentar descripciones claras y detalladas de temas complejos integrando subtemas, desarrollando puntos particulares y concluyendo de manera adecuada.",
                "Comunicarse de forma espontánea, mostrando a menudo fluidez y facilidad de expresión sorprendentes incluso en tramos largos y complejos de discurso.",
                "Seleccionar una formulación adecuada de una amplia gama de lenguaje para expresarse claramente, sin tener que restringir lo que quieren decir.",
                "Tener un buen dominio de un amplio repertorio léxico que permite superar fácilmente las lagunas con circunloquios; poco búsqueda evidente de expresiones o estrategias de evitación.",
                "Tener un buen dominio de expresiones idiomáticas y coloquialismos con errores menores ocasionales, pero sin errores significativos de vocabulario.",
                "Mantener consistentemente un alto grado de precisión gramatical; los errores son raros y difíciles de detectar.",
                "Variar la entonación y colocar el acento de las oraciones correctamente para expresar matices de significado.",
                "Usar el lenguaje de manera flexible y efectiva para fines sociales, incluido el uso emocional, alusivo y de bromas.",
                "Escribir textos claros y bien estructurados y expresar puntos de vista detalladamente.",
                "Escribir exposiciones detalladas de temas complejos en una carta, un ensayo o un informe, subrayando los problemas relevantes.",
                "Escribir diferentes tipos de textos en un estilo apropiado para el lector que se tiene en mente.",
              ],
            },
          ],
          footer: [
            {
              type: "p",
              class: "fw-bold text-blue2",
              text: "Preparación para el examen",
            },
            {
              type: "p",
              text: "En el nivel C1, el examen de salida designado es el C1 Advanced. El programa de 25 semanas está estructurado para proporcionar práctica y análisis de preguntas de examen de Cambridge en contexto y dentro del marco de un curso de inglés general. Hay ocho semanas completas de ejercicios, actividades y práctica al estilo de Cambridge, intercaladas en intervalos de tres semanas en el programa. La semana 25 del curso está dedicada únicamente al examen de Cambridge, con los estudiantes trabajando en ejemplos de exámenes anteriores.",
            },
            {
              type: "p",
              text: "A lo largo del curso, los estudiantes se familiarizarán con el tipo de preguntas, actividades y lenguaje que se evaluarán. Esto constituye alrededor de un tercio del contenido total de un curso general que se centra en la eficiencia y efectividad comunicativa. Se ofrecerán a los estudiantes más ejemplos de práctica y ejercicios a medida que se acerquen al final de su curso por parte del coordinador del examen del nivel C1.",
            },
          ],
        },
      },
      button: "¡Habla con nuestros agentes!",
    },
    section3: {
      title: "Exámenes finales de curso",
      text: "Nuestros profesores animan y preparan a los estudiantes para realizar los exámenes al final de su curso. Estos exámenes tienen reconocimiento global y impulsarán tu perfil profesional.",
    },
  },
  accreditations: {
    title: "Estándares de alta calidad que buscan nuestros estudiantes",
    breadcr: ["Sobre Nosotros", ">", "Asociados y Acreditaciones"],
    section: {
      title1:
        "NED College se asocia con orgullo a grandes instituciones para garantizar los estándares de alta calidad que nuestros estudiantes buscan. Estas acreditaciones contribuyen a la protección del consumidor y garantizan que todos nuestros servicios cumplan con los requisitos exigidos por la ley.",
    },
    items: [
      {
        logo: "logo_eaquals",
        title: "EAQUALS - Excelencia en Educación Lingüística",
        body: "NED College fue inspeccionado por Eaquals en 2023, una organización reconocida a nivel internacional que se enfoca en garantizar la excelencia en la educación lingüística, y cumplió con los altos estándares requeridos para la acreditación de Eaquals. La enseñanza, los programas de cursos, así como la organización de los cursos, los recursos de aprendizaje, las pruebas y evaluaciones, fueron todos considerados de alta calidad. Se encontró que la institución se preocupa mucho por proteger el bienestar de sus clientes y personal, y todos los materiales publicitarios producidos por la institución son precisos y verídicos. Con la acreditación de EAQUALS, puede estar seguro al elegir NED College para una experiencia educativa superior.",
      },
      {
        logo: "logo_asic",
        title:
          "ASIC - Servicio de Acreditación para Escuelas, Colegios y Universidades Internacionales",
        body: "Esta organización inspecciona instituciones educativas a nivel internacional y su objetivo principal es asegurar que los contenidos, programas y garantía de calidad de la institución cumplan con todos los requisitos reglamentarios. La acreditación es una confirmación de que la escuela ha sido evaluada y cumple con altos estándares de educación y buenas prácticas. Por lo tanto, puede estar seguro de una experiencia de aprendizaje positiva.",
      },
      {
        logo: "logo_ilep",
        title: "Lista Provisional de Programas Elegibles ILEP",
        body: "Esto fue implementado por el Departamento de Justicia e Igualdad el 20 de enero de 2016. Solo las escuelas que están en la lista pueden recibir estudiantes no europeos para cursos a largo plazo. NED College está en la lista provisional de escuelas.",
      },
      {
        logo: "logo_progressive",
        title: "PCN Progressive College Network",
        body: "La Progressive College Network es una organización formada para satisfacer la demanda de un cuerpo representativo alternativo para la comunidad de colegios privados en Irlanda.",
      },
      {
        logo: "logo_academy_plus",
        title: "Academy Plus Insurance Brokers Learner Protection",
        body: "De acuerdo con las regulaciones nacionales actuales, todos los estudiantes matriculados en cursos de 3 meses o más de duración están obligados a adquirir la Protección del Estudiante como parte de las tasas del curso. Se trata de un seguro que protege las tasas del estudiante en caso de que ocurra algo inesperado en la escuela.",
      },
      {
        logo: "logo_cambridge",
        title: "University of Cambridge ESOL Examinations",
        body: "La Universidad de Cambridge ofrece la gama más reconocida de cualificaciones en inglés en forma de exámenes de Cambridge ESOL. Su red extendida incluye más de 2,700 centros y 20,000 examinadores. NED College ofrece preparación para los exámenes de Cambridge y se pueden tomar en nuestro centro local de exámenes de Cambridge en UL.",
      },
      {
        logo: "logo_ielts",
        title: "IELTS",
        body: "El Sistema Internacional de Evaluación del Idioma Inglés es una prueba internacional estandarizada de competencia en el idioma inglés para hablantes no nativos. Es gestionado conjuntamente por el British Council, IDP: IELTS Australia y Cambridge Assessment English, y fue establecido en 1989.",
      },
      {
        logo: "logo_lap",
        title: "Protección de Estudiantes Matriculados de Academy",
        body: "De acuerdo con las regulaciones nacionales actuales, todos los estudiantes matriculados en cursos de 3 meses o más de duración están obligados a adquirir la Protección del Estudiante como parte de las tasas del curso. Se trata de un seguro que protege las tasas del estudiante en caso de que ocurra algo inesperado en la escuela.",
      },
      {
        logo: "logo_tie",
        title: "TIE",
        body: "TIE es una calificación moderna, innovadora y amigable de ESOL disponible internacionalmente. Otorgada por Gatehouse Awards, TIE ha sido diseñada para candidatos que no son hablantes nativos de inglés. Su objetivo es permitir a los candidatos desarrollar sus habilidades de expresión oral, comprensión auditiva, lectura y escritura en todos los niveles del MCER (A1 a C2), ayudándolos a prepararse para la educación superior o el empleo profesional.",
      },
    ],
  },
  campus_dublin: {
    title: "Campus de Dublín",
    breadcr: ["Nuestros campus", ">", "Dublín"],
    section1: {
      title:
        "Dublín es la capital de Irlanda, una ciudad cosmopolita y vibrante que puede ser tan acogedora como un pub irlandés.",
      text: "Originalmente fundada por los vikingos, esta ciudad, rodeada de montañas y mar, lo tiene todo.\\n              Con su impecable combinación de monumentos clásicos, un excelente ambiente y\\n              vida nocturna, innumerables actividades recreativas y áreas verdes para pasear, Dublín se ha\\n              convertido en uno de los destinos más populares para que los estudiantes internacionales experimenten una\\n              gran aventura en el extranjero.",
    },
    section2: {
      text: "Dublín ha sido el hogar de",
      text1: "NED College durante más de 10 años.",
      text2:
        "Durante ese tiempo, hemos crecido y expandido para proporcionar todo lo que un estudiante necesita para aprender el idioma más importante del mundo.",
    },
    section3: {
      title: "Campus de Dublín",
      text1:
        "El Campus de NED College en Dublín tiene 2 edificios construidos en 1750 - todos ubicados en el corazón de la ciudad,\\n            accesibles a través de varios servicios de transporte público o caminando.",
      text2:
        "En nuestro campus de Dublín, nos comprometemos a proporcionar un ambiente cómodo y de apoyo\\n            para nuestros estudiantes multiculturales, mejorando su experiencia estudiantil y convirtiéndolo en\\n            un lugar ideal para estudiar y crecer.",
    },
    section4: {
      cards: [
        {
          icon: "girl",
          title: "Recepción",
          body: "Área de recepción, donde nuestros amigables recepcionistas asisten a los estudiantes con sus preguntas.",
        },
        {
          icon: "cuttlery",
          title: "Cafetería",
          body: "Hermosa cafetería que ofrece a nuestros estudiantes una variedad de bebidas calientes, refrescos y opciones de comida.",
        },
        {
          icon: "classroom",
          title: "Aulas",
          body: "Otra característica clave de nuestro campus son las aulas modernas y completamente equipadas.",
        },
        {
          icon: "building",
          title: "2 edificios",
          body: "Infraestructura de 2 edificios para apoyar y mejorar la experiencia estudiantil, convirtiéndolo en un lugar ideal para estudiar y crecer.",
        },
        {
          icon: "sofa",
          title: "Área de descanso",
          body: "También contamos con un área de descanso con una biblioteca, donde los estudiantes pueden reunirse para relajarse, charlar, estudiar o hacer nuevos amigos.",
        },
      ],
    },
    section5: {
      title: "ECHA UN VISTAZO A NUESTROS EDIFICIOS",
      button: "Quiero estudiar aquí",
    },
    section6: {
      title: "Lo que puedes encontrar cerca del Campus de NED College en Dublín",
      text1: "Paradas del principal",
      text2: "transporte público",
      text3: "en la ciudad",
      text4: "Principales",
      text5: "atracciones turísticas y monumentos",
      text6: "Centros comerciales, tiendas y",
      text7: "diferentes tipos de restaurantes",
    },
    testimonialsection: {
      title: "Echa un vistazo a lo que nuestros estudiantes dicen sobre NED College",
    },
    mapsection: {
      title: "Una mezcla de nacionalidades",
      body: "Cada mes en NED College, damos la bienvenida a estudiantes de todo el mundo. Para brindarte un servicio mejor y personalizado,",
      body1:
        "ofrecemos apoyo estudiantil en tu propio idioma antes de la llegada y durante tu período de estudio en Irlanda.",
    },
    section7: {
      title1: "Conoce nuestros edificios del Campus de Dublín",
      title2: "¿Qué estás esperando?",
      button: "Elige el campus de Dublín",
    },
  },
  campus_limerick: {
    title: "Campus de Limerick",
    breadcr: ["Nuestras sedes", ">", "Limerick"],
    section1: {
      title:
        "Fundada originalmente por los vikingos, Limerick es una ciudad tradicional donde se puede experimentar la auténtica cultura irlandesa.",
      text: "Limerick se encuentra en el medio oeste de Irlanda y tiene 191.000 habitantes, lo que la convierte en la tercera ciudad más grande del país. Siempre hay algo que hacer en la ciudad de Limerick, ya que cuenta con muchos lugares históricos fascinantes, antiguos pubs, zonas comerciales, eventos culturales, deliciosos restaurantes y excelente transporte público. Por eso, Limerick es el lugar perfecto para aprender inglés mientras disfrutas de la calidad de vida y el bajo costo que ofrece la ciudad en comparación con el resto del país.",
    },
    section2: {
      text: "En 2019 inauguramos nuestra nueva escuela en esta ciudad",
      text1:
        " ¡y ha sido un completo éxito! Desde entonces, hemos recibido cientos de estudiantes de diferentes países y cada mes llegan más.",
    },
    section3: {
      title: "Campus de Limerick",
      text: "El Campus de Limerick de NED College está ubicado en el corazón de la ciudad, ofreciendo instalaciones completamente nuevas y modernas para los estudiantes. Al igual que en Dublín, en nuestro campus de Limerick nos comprometemos a proporcionar un entorno de apoyo y confortable para nuestros estudiantes multicultural.",
    },
    section4: {
      cards: [
        {
          icon: "girl",
          title: "Recepción",
          body: "Área de recepción donde nuestros amigables recepcionistas ayudan a los estudiantes con sus preguntas.",
        },
        {
          icon: "cuttlery",
          title: "Cafetería",
          body: "Hermosa cafetería que ofrece a nuestros estudiantes una variedad de bebidas calientes, refrescos y opciones de comida.",
        },
        {
          icon: "classroom",
          title: "Aulas",
          body: "Otra característica clave de nuestro campus son las aulas modernas y totalmente equipadas.",
        },
        {
          icon: "building",
          title: "1 edificio",
          body: "Infraestructura de 1 edificio para respaldar y mejorar la experiencia del estudiante, convirtiéndolo en un lugar ideal para estudiar y crecer.",
        },
        {
          icon: "sofa",
          title: "Zona de descanso",
          body: "También contamos con una zona de descanso con biblioteca, donde los estudiantes pueden reunirse para relajarse, charlar, estudiar o hacer nuevos amigos.",
        },
        {
          icon: "disabled",
          title: "Baño para personas con discapacidad",
          body: "Baños limpios y modernos para personas con discapacidad.",
        },
      ],
    },
    section5: {
      title: "Echa un vistazo a nuestro Campus de Limerick",
      button: "Quiero estudiar aquí",
    },
    section6: {
      title: "Qué hay cerca del Campus de Limerick de NED College",
      text1: "Paradas de autobús para el principal",
      text2: "transporte público",
      text3: "en la ciudad",
      text4: "Muchas",
      text5: "atracciones turísticas y monumentos",
      text6: "Centros comerciales, tiendas,",
      text7: "muchos tipos diferentes de restaurantes",
      text8: "y entornos culturales",
    },
    testimonialsection: {
      title: "Mira lo que nuestros estudiantes dicen sobre NED College",
    },
    mapsection: {
      title: "Una mezcla de nacionalidades",
      body: "Cada mes en NED College damos la bienvenida a estudiantes de todo el mundo. Para ofrecerte un mejor servicio personalizado,",
      body1:
        "ofrecemos apoyo al estudiante en tu propio idioma antes de tu llegada y durante tu período de estudio en Irlanda.",
    },
    section7: {
      title1: "Conoce nuestro Campus de Limerick",
      title2: "¿Qué estás esperando?",
      button: "Elige el campus de Limerick",
    },
  },
  contact_us: {
    title: "Ponte en contacto",
    breadcr: ["Contáctanos"],
    section1: {
      title:
        "¡Vamos! ¡Da el primer paso para estudiar inglés en Irlanda! Estamos aquí para responder todas tus preguntas.",
    },
    section3: {
      title1: "Conoce nuestras sedes",
      title2: "Campus de Dublín",
    },
    section4: {
      title: "Campus de Limerick",
    },
  },
  privacy_policy: {
    title: "Política de Privacidad",
    breadcr: ["Sobre nosotros", ">", "Política de Privacidad"],
    title1: "Solicitud de consentimiento",
    text1:
      "NED College solicita permiso para utilizar información personal. Puede solicitar acceso a estos datos en cualquier momento o decirnos que los eliminemos de nuestros registros a menos que se mantengan por razones legales. Le pediremos que acepte esta política de privacidad durante el proceso de reserva / inscripción. Su consentimiento puede ser retirado en cualquier momento.",
    text2: "Si tiene alguna pregunta, por favor póngase en contacto con la escuela:",
    text3: "Por correo",
    text4: "Por correo electrónico",
    text5: "El Comisionado de Protección de Datos",
    items: [
      {
        title: "¿Quiénes somos?",
        body: [
          {
            type: "p",
            text: "NED College es un Centro de Educación de Idiomas (LEC) y somos responsables del procesamiento de cualquier información personal que proporcione a la escuela a través de nuestro sitio web www.ned.ie. Respetamos sus derechos a la privacidad y protección de su información personal. El propósito de este aviso de privacidad es explicar cómo recopilamos y utilizamos información personal para la provisión de nuestros servicios y el funcionamiento diario de la escuela, así como para describir su acceso y control sobre su información personal.",
          },
        ],
      },
      {
        title: "¿Qué es la información personal?",
        body: [
          {
            type: "p",
            text: "La información que se puede utilizar para identificarlo se conoce como información personal.",
          },
          {
            type: "p",
            text: "Cuando usted proporciona información personal a NED College, la escuela, como responsable del tratamiento de esa información, es responsable de cómo y por qué se guarda la información.",
          },
        ],
      },
      {
        title: "Tipos de información que podemos procesar",
        body: [
          {
            type: "p",
            text: "Recopilamos y procesamos varias categorías de información personal, incluyendo información básica como nombre, fecha de nacimiento y detalles de contacto. También podemos, si es necesario o requerido, recopilar detalles de pasaporte y visa, así como datos relacionados con condiciones médicas, necesidades especiales y requisitos particulares. También podemos ocasionalmente recopilar información en forma fotográfica o de video (con consentimiento previo).",
          },
        ],
      },
      {
        title: "¿Cómo procesamos su información personal?",
        body: [
          {
            type: "p",
            text: "El procesamiento de la información personal está controlado y regulado por el Reglamento General de Protección de Datos (GDPR).",
          },
          {
            type: "p",
            text: "Para cumplir con el GDPR, NED College está obligado a garantizar que todos los datos personales se mantengan actualizados, se almacenen de manera segura y se destruyan de manera segura, se utilicen solo para el propósito para el que se recopilan, se protejan contra la pérdida y el acceso y divulgación no autorizados.",
          },
        ],
      },
      {
        title: "¿Para qué utilizamos su información personal?",
        body: [
          {
            type: "p",
            text: "Solo utilizamos su información personal para fines específicos relacionados con la gestión administrativa, académica y empresarial de la escuela, incluyendo:",
          },
          {
            type: "ul",
            list: [
              "Inscripción escolar",
              "Procesar transacciones financieras",
              "Ayudar con solicitudes de visa",
              "Ordenar seguro médico o de protección del alumno",
              "Para fines de inmigración",
              "Reservar alojamiento",
              "Para la promoción de la escuela",
            ],
          },
          {
            type: "p",
            text: "Si deseamos utilizar su información personal para algún nuevo propósito, debemos informarle de nuestros planes con anticipación y solicitar su consentimiento previo para cualquier nuevo procesamiento.",
          },
        ],
      },
      {
        title: "Seguridad",
        body: [
          {
            type: "p",
            text: "Nos comprometemos a garantizar que su información personal esté segura con nosotros. Toda la información enviada directamente o a través del sitio web está completamente protegida en línea y fuera de línea.</p> <p>Solo los miembros del personal que necesiten la información para realizar un trabajo específico tendrán acceso a su información personal. Todas las computadoras y sistemas de archivo en los que NED College almacena información se mantienen en un entorno seguro.",
          },
        ],
      },
      {
        title: "Compartir con terceros",
        body: [
          {
            type: "p",
            text: "No compartiremos su información personal con nadie fuera de la escuela a menos que tengamos su permiso expreso.",
          },
          {
            type: "p",
            text: "En ningún caso venderemos, alquilaremos ni compartiremos su información personal con terceros.",
          },
        ],
      },
      {
        title: "Transferencia de información al extranjero",
        body: [
          {
            type: "p",
            text: "Su información personal solo podrá ser transferida fuera de la UE si nos lo permite.",
          },
        ],
      },
      {
        title: "¿Cuánto tiempo mantendremos su información?",
        body: [
          {
            type: "p",
            text: "Debido a obligaciones/regulaciones legales y operativas, es posible que conservemos su información personal por un período indefinido a menos que solicite que se elimine de nuestro sistema.",
          },
        ],
      },
      {
        title: "¿Cuáles son sus derechos legales?",
        body: [
          {
            type: "p",
            class: "fw-bold",
            text: "Según el GDPR, tiene ciertos derechos legales para controlar su información personal y la forma en que la procesamos. Esto incluye:",
          },
          {
            type: "ul",
            list: [
              "Derecho de acceso",
              "Derecho a corregir información inexacta o actualizar información incompleta",
              "Derecho a restringir el procesamiento",
              "Derecho a recibir información en formato portátil",
              "Derecho a oponerse al procesamiento de datos con fines para los que no se proporcionaron",
              "Derecho a retirar su consentimiento en cualquier momento",
              "Derecho a presentar una queja ante el Comisionado de Protección de Datos",
            ],
          },
        ],
      },
    ],
  },
  services: {
    title: "Más que <br> cursos de inglés",
    breadcr: ["Vida estudiantil", ">", "Servicios"],
    title2:
      "¡Nuestra escuela ofrece mucho más que cursos de inglés, ofrecemos toda la experiencia!",
    items: [
      {
        image: "services_1",
        title: "Actividades Extra",
        body: [
          {
            type: "p",
            class: "",
            text: "NED College cree que el tiempo que pasas fuera del aula es muy importante para ayudarte a mejorar tu idioma y hacer nuevos amigos. Por lo tanto, proporcionamos actividades relacionadas con el proceso de aprendizaje en sí, como nuestras clases extra gratuitas en conversación, pronunciación, gramática y cómo crear tu currículum, así como actividades al aire libre, excursiones y viajes, como nuestro viaje a Marruecos. Cada mes, puedes encontrar el horario completo en los tablones de anuncios de la escuela, nuestros canales de redes sociales y en nuestra aplicación.",
          },
        ],
      },
      {
        image: "services_2",
        title: "Aplicación NED College",
        body: [
          {
            type: "p",
            class: "",
            text: "Otra gran fortaleza a tener en cuenta es que NED College ofrece una increíble aplicación para facilitar la vida de los estudiantes. La aplicación NED College es la mejor herramienta para realizar un seguimiento de tu vida académica, verificar tu asistencia, solicitar vacaciones, descubrir las novedades en nuestro calendario escolar, unirte a actividades y más.",
          },
          {
            type: "p",
            class: "fw-bold",
            text: "Descárgala GRATIS desde Google Store o Apple Store y regístrate con tu ID de estudiante.",
          },
        ],
      },
      {
        image: "services_3",
        title: "Apoyo al estudiante",
        body: [
          {
            type: "p",
            class: "",
            text: "En NED College, los estudiantes pueden contar con un apoyo profesional en su propio idioma. Cada miembro de nuestro equipo ha estudiado en el extranjero y ha vivido la misma experiencia que nuestros estudiantes. Por lo tanto, te ayudarán antes de tu llegada a Irlanda y durante tu estancia aquí. Nuestros asesores de estudiantes comprenden COMPLETAMENTE lo que significa vivir en el extranjero. Te informarán, de principio a fin, sobre el curso de inglés, visado, alojamiento, transporte público, permiso de trabajo y cómo aprovechar al máximo tu experiencia en Dublín o Limerick.",
          },
        ],
      },
      {
        image: "services_4",
        title: "Alojamiento Temporal en Irlanda",
        body: [
          {
            type: "p",
            class: "",
            text: "Nuestro objetivo es que te sientas como en casa en Irlanda. Tu alojamiento es una parte extremadamente importante de toda tu experiencia. Las diferentes ubicaciones donde alojamos a los estudiantes están cerca de transporte público, centros comerciales, supermercados y bancos. Con NED College puedes estar seguro de que te proporcionaremos un alojamiento de calidad que se adapte mejor a tus necesidades. Trabajamos con Familias Anfitrionas, Hostales y Alojamiento para Estudiantes. Consulta con nuestro equipo para ver cuál se adapta mejor a tus necesidades y presupuesto.",
          },
        ],
      },
      {
        image: "services_5",
        title: "Recogida en el Aeropuerto",
        body: [
          {
            type: "p",
            class: "",
            text: "Cuando llegas a Dublín o Limerick para cursar nuestros cursos de inglés, se puede organizar un servicio de recogida en el aeropuerto. Este servicio asegura una llegada conveniente y segura a tu residencia, hotel o hostal después de aterrizar.",
          },
        ],
      },
      {
        image: "services_6",
        title: "Tarjeta de Estudiante NED College",
        body: [
          {
            type: "p",
            class: "",
            text: "NED College tiene su propia tarjeta de estudiante que ofrece descuentos para nuestros alumnos en varias tiendas, restaurantes, cines y más. Todos los estudiantes pueden obtener esta tarjeta y será válida durante el periodo de estancia del estudiante en Irlanda. ¡Es gratuita para los estudiantes y garantiza descuentos y ofertas especiales!",
          },
        ],
      },
      {
        image: "services_7",
        title: "Protección al Estudiante Inscrito",
        body: [
          {
            type: "p",
            class: "",
            text: "De acuerdo con las regulaciones nacionales actuales, todos los estudiantes inscritos en cursos de más de 3 meses de duración están obligados a comprar la Protección al Estudiante como parte de las tasas del curso. Este seguro protege las tarifas del estudiante en caso de que algo suceda en la escuela.",
          },
        ],
      },
      {
        image: "services_8",
        title: "Seguro Médico",
        body: [
          {
            type: "p",
            class: "",
            text: "Te brindaremos apoyo para solicitar tu Seguro Médico después de tu llegada a Irlanda y antes de ir a la Oficina de Inmigración. Recuerda que el seguro médico es obligatorio para los estudiantes que necesitan visado.",
          },
        ],
      },
      {
        image: "services_9",
        title: "Día de Inducción",
        body: [
          {
            type: "p",
            class: "",
            text: "Tan pronto como el estudiante llega y antes de comenzar el curso, nuestro equipo llevará a cabo un día de inducción. ¡La reunión es de suma importancia para nosotros! Se realiza para informar a los estudiantes todo sobre NED College y la experiencia que están a punto de comenzar. Todos estos detalles se explicarán en sus propios idiomas, ¡para que se comprendan completamente!",
          },
        ],
      },
      {
        image: "services_10",
        title: "Exámenes y Certificaciones de Inglés",
        body: [
          {
            type: "p",
            class: "",
            text: "Creemos que establecer un objetivo es la mejor manera de motivarte y ayudarte a alcanzar tus objetivos. Los exámenes de inglés, como los Exámenes de Cambridge y TIE, son un gran motivador para estudiar y esforzarte durante tu tiempo en Irlanda. Aquí en NED College ofrecemos preparación para exámenes para ayudarte a alcanzar esos importantes objetivos. Recuerda que para los estudiantes de NED College que se inscriben en un curso de 25 semanas, es obligatorio realizar un examen al final del programa.",
          },
        ],
      },
      {
        image: "services_11",
        title: "Estudiante del Mes",
        body: [
          {
            type: "p",
            class: "",
            text: "Cada mes, nuestros profesores nominan a un estudiante como el 'Estudiante del Mes'. Esto puede deberse a tu progreso, participación en clase o tal vez tengas esa cualidad especial que te hace un gran estudiante.",
          },
        ],
      },
    ],
    button: "Quiero más información",
  },
  student_visa: {
    title: "Estudiar y trabajar en Irlanda",
    section1: {
      title: "Visa de estudiante y reglas de inmigración",
      subtitle:
        "Obtener una visa de estudiante para residir legalmente en Irlanda por un periodo\n            superior a 90 días requiere la solicitud de un Permiso de Residencia Irlandés (IRP)",
      text1:
        "Tenga en cuenta que ciertas nacionalidades deben solicitar una visa antes de viajar\n            a Irlanda. Puede encontrar una lista de estas nacionalidades en la página de la oficina\n            de inmigración irlandesa",
      text2: "o poniéndose en contacto con la embajada correspondiente.",
    },
    section2: {
      title:
        "Cuando se emigra a Irlanda desde un país no europeo para estudiar inglés, es\n            esencial tener la documentación adecuada para garantizar un proceso de solicitud de visa\n            fluido y exitoso.",
      subtitle:
        "Los siguientes documentos son necesarios tanto para cursos de inglés a corto como\n            a largo plazo:",
      subtitle_left: "Curso de inglés a corto plazo",
      list1_left: "Pasaporte original, válido durante todo el período de estancia en el país",
      list2_left: "Boletos de vuelo de regreso al país de origen",
      list3_left:
        "Carta de solicitud del NED College, que incluye información sobre el curso y\n                confirmación de que todas las tarifas han sido pagadas",
      list4_left:
        "Carta de confirmación del lugar de residencia, casa, hotel o albergue donde el\n                estudiante se hospedará",
      list5_left: "Prueba financiera, que oscila entre €500 y €700 por mes",
      list6_left: "Seguro de salud privado",
      text1: "Algunas nacionalidades deben solicitar la visa antes de viajar a Irlanda:",
      subtitle_right: "Curso de inglés a largo plazo",
      list1_right: "Pasaporte original, válido durante todo el período de estancia en el país",
      list2_right:
        "Carta de solicitud del NED College, que incluye información sobre el curso y\n                confirmación de que todas las tarifas han sido pagadas",
      list3_right:
        "Carta de confirmación del lugar de residencia, casa, hotel o albergue donde el\n                estudiante se hospedará",
      list4_right: "Seguro gubernamental (obligatorio) y seguro de salud privado (opcional)",
      list5_right:
        "Prueba financiera de €3,000 (a partir del 01 de julio de 2023, se requerirá obtener\n                evidencia de que tiene acceso a al menos €10,000 por año de sus estudios. Si la duración\n                del curso es inferior a 6 meses, debe tener acceso a €4,200).",
      list6_right: "€300 para la visa y el registro del IRP",
      text2: "Algunas nacionalidades deben solicitar la visa antes de viajar a Irlanda",
      button: "Consultar una lista de nacionalidades",
    },
    section3: {
      title1: " Aunque la persona solicitante es responsable de obtener la Visa,",
      title2: "nuestros asesores de estudiantes le ayudarán durante todo el proceso de solicitud.",
      button: "Quiero hablar con un agente",
    },
    section4: {
      title: "Revisión de la solicitud",
      text1: "Después de enviar los documentos necesarios y pagar la tarifa,",
      text2:
        "la oficina de inmigración revisará los documentos y otorgará el permiso de residencia,",
      text3:
        "lo cual incluirá el registro de los datos personales del solicitante (huellas dactilares y foto).",
      text4:
        "Todo el proceso suele tardar alrededor de una hora, aunque a veces puede haber más afluencia. Al completarse, la oficina colocará un sello en el pasaporte que indica el",
      text5: "permiso de residencia y las horas de trabajo permitidas (Sello 2).",
      card_icon: "exclamation",
      card_title:
        "Es importante tener en cuenta que los estudiantes deben llevar siempre su IRP al viajar fuera de Irlanda y volver al país.",
      card_body:
        "Además, no se permite salir del país y volver como turista después de que expire la visa. Nuestros asesores de estudiantes están disponibles para ayudar con todo el proceso de solicitud. Para obtener más información, consulte el sitio web de la Oficina de Inmigración Irlandesa y póngase en contacto con su embajada para obtener detalles adicionales.",
    },
  },
  faqs: {
    title: "Preguntas frecuentes",
    breadcr: ["Preguntas frecuentes"],
    section1: {
      title: "Sabemos que prepararse para viajar al extranjero no es fácil.",
      text: "Es por eso que hemos preparado estas preguntas frecuentes especiales para ayudarte a comprender mejor todo lo que necesitas saber sobre estudiar inglés y trabajar en Irlanda.",
    },
    sections: [
      {
        title: "Antes de viajar a Irlanda",
        items: [
          {
            title: "¿Por qué estudiar en el extranjero?",
            body: [
              {
                type: "p",
                class: "",
                text: "Estudiar en el extranjero es un sueño perseguido por muchos jóvenes y, más recientemente, por personas de todas las edades. La decisión de estudiar en el extranjero debe tomarse individualmente. Pregúntate qué motivación tienes para perseguir este sueño. Aunque tus motivaciones son personales y depende totalmente de ti tomar una decisión al respecto, estudios han demostrado que las personas que han estudiado en el extranjero han mejorado no solo sus habilidades lingüísticas, sino también han aumentado su confianza, autoestima y capacidad para resolver problemas y manejar la presión. Para obtener más información al respecto, echa un vistazo a este estudio:",
              },
              {
                type: "a",
                class: "",
                link: "https://www.iesabroad.org/study-abroad/benefits",
                text: "https://www.iesabroad.org/study-abroad/benefits",
              },
            ],
          },
          {
            title: "¿Por qué estudiar en Irlanda?",
            body: [
              {
                type: "p",
                class: "",
                text: "Irlanda se ha vuelto cada vez más popular entre estudiantes de todo el mundo debido a que sus leyes de inmigración son consideradas flexibles y abiertas a estudiantes no europeos. Los estudiantes pueden venir para estudios a corto o largo plazo, en este último caso es posible trabajar mientras estudias en el país. El proceso de solicitud de visa es bastante sencillo, ya que se realiza después de la llegada del estudiante al país. Además de los motivos anteriores, Irlanda es un país hermoso y muy histórico, que ofrece varios tipos de actividades culturales y la oportunidad de conocer gente de todas partes. No hace falta decir que Irlanda está muy bien ubicada y ofrece los vuelos más económicos a otros países de Europa.",
              },
            ],
          },
          {
            title: "¿Dónde estudiar inglés en Irlanda?",
            body: [
              {
                type: "p",
                class: "",
                text: "Hay muchas ciudades en Irlanda que ofrecen oportunidades para aprender inglés y trabajar. Las favoritas son Dublín, Cork, Galway y Limerick. En NED College, puedes elegir entre ",
              },
              {
                type: "a",
                class: "",
                link: "https://ned.ie/about/dublin",
                text: "Dublín",
              },
              {
                type: "p",
                class: "",
                text: "y ",
              },
              {
                type: "a",
                class: "",
                link: "https://ned.ie/about/limerick",
                text: "Limerick",
              },
            ],
          },
          {
            title: "¿Qué es un ciudadano no europeo?",
            body: [
              {
                type: "p",
                class: "",
                text: "Un ciudadano no perteneciente a la UE es una persona que proviene de países que no forman parte del acuerdo de la UE. Los ciudadanos de la UE tienen la libertad de mudarse a otro país de la UE para trabajar sin necesidad de un permiso de trabajo. Las únicas excepciones a esto son las personas procedentes de Islandia, Liechtenstein y Noruega, ya que sus ciudadanos pueden trabajar en la UE en igualdad de condiciones que los ciudadanos de la UE, ya que pertenecen al Espacio Económico Europeo. Para verificar los derechos exactos con respecto a su país de origen, acceda a:",
              },
              {
                type: "a",
                class: "",
                link: "http://ec.europa.eu/social/main.jsp?catId=470&langId=es",
                text: "http://ec.europa.eu/social/main.jsp?catId=470&langId=es",
              },
            ],
          },
          {
            title: "¿Puedo trabajar y estudiar en Irlanda como ciudadano NO europeo?",
            body: [
              {
                type: "p",
                class: "",
                text: "Sí. Esto es parte de lo que hace que Irlanda sea un destino tan atractivo para su programa de estudios en el extranjero. Al inscribirse en un curso a largo plazo, se le permite trabajar 20 horas a la semana durante los horarios regulares y 40 horas durante las vacaciones de verano y Navidad (las fechas específicas están definidas por las autoridades de inmigración irlandesas). Los titulares de la visa de Estampa 2 están autorizados a trabajar a tiempo completo de acuerdo con las disposiciones de la legislación laboral durante los meses de junio, julio, agosto y septiembre, y desde el 15 de diciembre hasta el 15 de enero inclusive. En todos los demás momentos, estarán limitados a trabajar 20 horas por semana. Obtenga más información: ",
              },
              {
                type: "a",
                class: "",
                link: "http://www.inis.gov.ie/en/INIS/Pages/Frequently%20Asked%20Questions%20-%20Students",
                text: "http://www.inis.gov.ie/en/INIS/Pages/Frequently%20Asked%20Questions%20-%20Students",
              },
            ],
          },
          {
            title: "¿Puedo trabajar después de estudiar en Irlanda?",
            body: [
              {
                type: "p",
                class: "",
                text: "Si no tienes pasaporte europeo, solo puedes trabajar mientras estudias en Irlanda. Sin embargo, al completar un nivel de educación superior (Licenciatura, Postgrado, Maestría o Doctorado), podrías obtener un permiso de trabajo de 1 a 2 años.",
              },
            ],
          },
          '{"title":"¿Qué debo estudiar en Irlanda?","body":[{"type":"p","text":"Puedes estudiar cualquier curso en el que estés interesado siempre y cuando hayas sido aceptado por una Institución Irlandesa.\n                Ten en cuenta que para poder trabajar a tiempo parcial en Irlanda, deberás estar matriculado en un curso a tiempo completo. Estos incluyen:\n                Inglés, Diploma Nacional Superior, Maestría y Doctorado. Te recomendamos que comiences tus estudios con un\n                Curso de Inglés, de preferencia en el Colegio NED, ya que nos comprometemos a brindarte el mejor apoyo,\n                para que aumentes tus posibilidades de ser aceptado en un curso de mayor nivel más adelante."}]}',
          {
            title: "¿Cuál es la edad mínima para hacer un programa de intercambio estudiantil?",
            body: [
              {
                type: "p",
                text: "En el Colegio NED nos complace dar la bienvenida a estudiantes que tengan 18 años o más. Si tienes menos de 18 años, solo podemos aceptarte para un curso a corto plazo, de 1 a 12 semanas de duración. Las visas de estadía corta 'C' para niños menores de 18 años deben indicar si el niño viaja solo (sin acompañante) o con un adulto (acompañado). Si el niño está acompañado, la(s) persona(s) nombrada(s) en la visa del niño deben estar con él durante todo el viaje. De lo contrario, al niño no se le permitirá viajar. Para obtener más información:",
              },
              {
                type: "a",
                link: "http://www.inis.gov.ie/en/INIS/Pages/visa-short-stay-children",
                text: "http://www.inis.gov.ie/en/INIS/Pages/visa-short-stay-children",
              },
            ],
          },
          {
            title: "¿Qué es una Stamp 2?",
            body: [
              {
                type: "p",
                text: "Es un permiso para estudiar en Irlanda. La Stamp 2 indica permiso para estudiar un curso a tiempo completo en la lista provisional de programas elegibles (ILEP, por sus siglas en inglés), por un período específico y sujeto a condiciones. Según la regulación irlandesa, el estudiante debe estar inscrito en uno de los siguientes cursos: idioma inglés, diploma de educación superior, licenciatura, maestría (postgrado), doctorado. Para obtener más información, visite: ",
              },
              {
                type: "a",
                link: "http://www.inis.gov.ie/en/INIS/Pages/registration-stamps#stamp2",
                text: "http://www.inis.gov.ie/en/INIS/Pages/registration-stamps#stamp2",
              },
            ],
          },
          {
            title: "¿Necesito solicitar una visa para estudiar en Irlanda?",
            body: [
              {
                type: "p",
                text: "Dependerá de la duración que tengas pensado estudiar en Irlanda y también del país del que provengas.\n                Para verificar si los ciudadanos de tu país necesitan una visa para ingresar a Irlanda, haz clic en este enlace: ",
              },
              {
                type: "p",
                link: "http://www.inis.gov.ie/en/INIS/Pages/check-irish-visa",
                text: "http://www.inis.gov.ie/en/INIS/Pages/check-irish-visa",
              },
              {
                type: "p",
                text: "En general, si planeas estudiar en Irlanda por menos de 3 meses, no tendrás que solicitar una visa. Sin embargo, si tienes la intención de trabajar mientras estudias en Irlanda, deberás solicitar una visa una vez que llegues al país. Esta regla se aplica solo a los ciudadanos no europeos. ",
              },
            ],
          },
          {
            title: "¿Debo reservar mi curso de inglés antes de que comience mi viaje?",
            body: [
              {
                type: "p",
                text: "Sí, debes hacerlo. Ten en cuenta que la carta de la escuela que indique que estás inscrito en un curso de inglés es uno de los\n                documentos más importantes que debes presentar al cruzar la frontera a Irlanda. Este requisito se aplica tanto a\n                cursos cortos como a cursos de larga duración. Demostrar que estás ingresando al país por motivos educativos será fundamental\n                para tu éxito.",
              },
            ],
          },
          {
            title:
              "¿Qué documentos debo presentar en el aeropuerto en el control de fronteras irlandesas?",
            body: [
              {
                type: "p",
                text: "Al llegar a Irlanda deberá presentar su pasaporte (válido por al menos 6 meses y/o el período que pretenda permanecer en el país, lo que significa que si reservó un curso de 8 meses, su pasaporte debe ser válido para los próximos 8 meses), <strong>la carta de la escuela, la carta de alojamiento, comprobante de fondos (estado de cuenta o efectivo) y los boletos de vuelo de regreso impresos.</strong>",
              },
            ],
          },
          {
            title: "¿Cuál es el nivel de inglés requerido para estudiar en el extranjero?",
            body: [
              {
                type: "p",
                text: "Si vienes a aprender inglés, no requerimos ningún conocimiento del idioma, ya que ofrecemos cursos de inglés desde el nivel más elemental. Sin embargo, si tienes la intención de estudiar cursos de nivel superior, se te pedirá que demuestres un nivel más alto, posiblemente incluso avanzado, de inglés.",
              },
            ],
          },
          {
            title: "¿Con cuánta antelación debo reservar mi curso?",
            body: [
              {
                type: "p",
                text: "Depende de nuestra disponibilidad. Es posible que necesite más tiempo para ahorrar suficiente dinero para venir a Irlanda.\n                Sin embargo, si ya has tomado una decisión y decides venir de inmediato, haremos todo lo posible para\n                garantizarte un lugar en nuestra escuela. Además, te recomendamos reservar tu curso con tres meses de antelación para\n                garantizar un lugar, mejores promociones de vuelo, etc. Una vez que hayas reservado y pagado completamente tus tasas,\n                tendrás que viajar a Irlanda dentro del próximo año. Si este período expira, ya no te alojaremos y no tendrás derecho a\n                recibir ningún reembolso.",
              },
            ],
          },
          {
            title: "¿Puedo trabajar en Irlanda mientras hago un curso de inglés a corto plazo?",
            body: [
              {
                type: "p",
                text: "No, no puedes. Puedes estudiar en Irlanda tomando un curso a corto o largo plazo. La diferencia es que en un curso a corto plazo no tienes permiso para trabajar. Sin embargo, puedes sumergirte en la cultura irlandesa mientras vives en el país. Esta opción se recomienda para aquellos que no tienen mucho tiempo para viajar al extranjero y están dispuestos a usar sus vacaciones laborales para viajar y estudiar.",
              },
            ],
          },
          {
            title: "¿Qué tipo de cursos me permiten trabajar en Irlanda?",
            body: [
              {
                type: "p",
                text: "Para obtener un Sello 2, debes estar inscrito en un curso de larga duración con una duración mínima de\n                8 meses (programa de trabajo y estudio: curso de inglés de 6 meses + vacaciones de 2 meses).",
              },
            ],
          },
          {
            title: "¿Cuántas horas puedo trabajar en Irlanda?",
            body: [
              {
                type: "p",
                text: "Una vez matriculado en un curso de inglés a tiempo completo, se te permite trabajar en Irlanda durante 20 horas a la semana en meses regulares y hasta 40 horas durante los meses de verano y las vacaciones de Navidad. Los titulares de la visa Stamp 2 tienen permiso para trabajar a tiempo completo de acuerdo con las disposiciones legales de empleo durante los meses de junio, julio, agosto y septiembre, y desde el 15 de diciembre hasta el 15 de enero inclusive. En todos los demás momentos estarán limitados a trabajar 20 horas por semana.",
              },
            ],
          },
          {
            title: "¿Necesito seguro de salud?",
            body: [
              {
                type: "p",
                text: "Sí. Si eres ciudadano no europeo, se te requerirá tener un seguro médico privado.\nCon esto, estarás protegido en caso de emergencias médicas mientras vives en el extranjero. El seguro es obligatorio para programas a largo plazo. Al reservar tu curso con NED College, el seguro de salud estará incluido en el paquete, por lo que no tendrás que preocuparte por ello.",
              },
            ],
          },
          {
            title: "¿Cuál es el mejor momento del año para viajar?",
            body: [
              {
                type: "p",
                text: "El mejor momento es aquel que se ajusta a tus necesidades. Dependerá del estilo de vida de cada estudiante.\nSin embargo, recomendamos el verano por varias razones: algunos estudiantes regresan a casa, lo que facilita la\nbúsqueda de alojamiento; empleos y hacer nuevos amigos, ya que llega un nuevo grupo de personas.\nPara aquellos estudiantes que prefieren el invierno, es mejor llegar entre octubre y abril,\npara aquellos que prefieren el clima cálido, pueden venir de abril a septiembre. Si les gusta la fiesta, pueden venir\npara el Día de San Patricio en marzo o Halloween en octubre. En general, dependerá de tus gustos y objetivos.",
              },
            ],
          },
          {
            title: "¿Vende el Colegio NED boletos de avión?",
            body: [
              {
                type: "p",
                text: "No. Ofrecemos apoyo para ayudarte a encontrar las mejores opciones y precios. Como estudiante, también puedes aprovechar de tarifas y condiciones para estudiantes. Sin embargo, es responsabilidad exclusiva de los estudiantes reservar sus boletos de avión. Sin embargo, podríamos tener una asociación con algunas agencias de viajes, por lo que debes preguntar a tu agente.",
              },
            ],
          },
          {
            title: "¿Debo comprar un boleto de vuelta?",
            body: [
              {
                type: "p",
                text: "Sí. Es un requisito legal presentar el boleto de vuelta al llegar al control de frontera de Irlanda. No tener el boleto de vuelta puede resultar en deportación.",
              },
            ],
          },
          {
            title: "¿Debo ponerme vacunas especiales antes de mi viaje?",
            body: [
              {
                type: "p",
                text: "No. No hay ningún requisito legal. Sin embargo, de acuerdo con los CDC (Centros para el Control y la Prevención de Enfermedades), todos los viajeros deben asegurarse de estar al día con las vacunas de rutina antes de cualquier viaje. La vacuna recomendada antes de tu viaje es la Hepatitis A. Para obtener más información:",
              },
              {
                type: "a",
                link: "https://wwwnc.cdc.gov/travel/destinations/traveler/none/ireland",
                text: "https://wwwnc.cdc.gov/travel/destinations/traveler/none/ireland",
              },
            ],
          },
          {
            title: "¿Cuánto dinero debo llevar a Irlanda?",
            body: [
              {
                type: "p",
                text: "Si la duración de tu curso es inferior a 6 meses, debes tener acceso a 500€ por mes de tu estancia o 3000€, lo que sea menor. (A partir del 01 de julio de 2023, será necesario mostrar evidencia de que tienes acceso a al menos 700€ por mes de tu estancia o 4200€, lo que sea menor)",
              },
            ],
          },
          {
            title: "¿Cómo puedo hacer una cita en Inmigración Irlandesa?",
            body: [
              {
                type: "p",
                text: "Después de tu llegada a Irlanda, tu primera preocupación será solicitar tu visa de larga estancia. Recogerás todos los documentos necesarios en nuestra escuela, que son: carta de la escuela, certificado de seguro médico y tu declaración de prueba financiera.",
              },
              {
                type: "p",
                text: "Si has elegido Dublín, una vez que tengas todos los documentos, necesitas llamar al número gratuito 1800 800 630 para reservar tu cita. Si necesitas ayuda, solicita hablar con tu consultor. Por favor, verifica la página web de inmigración para obtener más información: ",
              },
              {
                type: "a",
                link: "https://www.irishimmigration.ie/burgh-quay-appointments",
                text: "https://www.irishimmigration.ie/burgh-quay-appointments",
              },
              {
                type: "p",
                text: "Si has elegido Limerick, por favor envía un correo electrónico a limerick.registration@garda.ie para reservar una cita.\n                *Recuerda que solo puedes reservar cuando estés en Irlanda.",
              },
            ],
          },
          {
            title:
              "¿Cómo puedo demostrar que tengo suficientes fondos para mantenerme durante mi estancia?",
            body: [
              {
                type: "p",
                class: "",
                text: "Puedes demostrar que tienes suficientes fondos presentando una de las siguientes opciones:",
              },
              {
                type: "ul",
                list: [
                  {
                    title: "Prueba de un banco irlandés",
                    text: "Si eliges esta opción, debes presentar un extracto original de un banco irlandés que muestre un saldo de €3,000",
                  },
                  {
                    title: "Prueba de un banco extranjero",
                    text: "Si eliges esta opción, debes presentar 2 extractos bancarios originales de un banco extranjero",
                  },
                  {
                    title: "Prueba de una empresa de servicios financieros en Irlanda",
                    text: "Si eliges esta opción, debes presentar una carta original de una empresa de servicios financieros en Irlanda que muestre que tiene €3,000 'en fideicomiso' para ti",
                  },
                  {
                    title:
                      "Prueba a través de una tarjeta de crédito prepagada o tarjeta de débito",
                    text: "Si eliges esta opción, debes presentar pruebas que demuestren ante la oficina de registro que tienes una o varias tarjetas de crédito prepagadas o tarjetas de débito con €3,000",
                  },
                ],
              },
              {
                type: "p",
                text: "Para obtener más información, consulta el sitio web de Inmigración: ",
              },
              {
                type: "a",
                link: "https://www.irishimmigration.ie/registering-your-immigration-permission/how-to-register-your-immigration-permission-for-the-first-time/requirements-and-documents-needed/",
                text: "https://www.irishimmigration.ie/registering-your-immigration-permission/how-to-register-your-immigration-permission-for-the-first-time/requirements-and-documents-needed/",
              },
            ],
          },
          {
            title: "¿Qué es una tarjeta IRP o GNIB?",
            body: [
              {
                type: "p",
                text: "La Tarjeta de Residencia Irlandesa (IRP) es un certificado de registro que demuestra que tienes permiso para residir y trabajar en Irlanda durante tu estancia. Una IRP tiene un coste de <strong>€300</strong> por persona cada vez que solicitas una visa de estudiante en el país. Puedes permanecer en Irlanda hasta por 2 años como estudiante de inglés. Esto significa que cada vez que renueves tu curso, tendrás que pagar la tarifa de €300 por una nueva tarjeta IRP. GNIB es como solían llamar a la tarjeta IRP. Ten en cuenta que esta tarjeta es muy importante porque, aunque no sirve como método de identificación oficial, es necesaria para fines de inmigración cada vez que sales o entras al país, por lo que recomendamos que la guardes en tu residencia y no la lleves en la calle.",
              },
            ],
          },
          {
            title: "¿Cómo puedo pagar mi tarjeta IRP?",
            body: [
              {
                type: "p",
                text: "Pague con tarjeta de crédito o débito en la oficina de registro de Burgh Quay y en las oficinas seleccionadas en todo el país.\n                Para pagar con tarjeta de crédito o débito, lleve su tarjeta consigo y úsela como de costumbre.",
              },
            ],
          },
        ],
      },
      '{"title": "Acerca de nuestra escuela", "items": [{"title": "¿Qué cursos de inglés ofrece el Colegio NED?", "body": [{"type": "p", "text": "Ofrecemos cursos de inglés general e IELTS. Obtén más información aquí: "}, {"type": "a", "link": "https://ned.ie/courses/", "text": "https://ned.ie/courses/"}]}, {"title": "¿Por qué debería elegir el Colegio NED?", "body": [{"type": "p", "text": "Nuestra moderna escuela cuenta con más de 20 aulas completamente equipadas en los campus de Dublín y Limerick, diseñadas para ofrecer a los estudiantes un entorno de aprendizaje óptimo donde puedan prosperar y alcanzar su máximo potencial. Además, tenemos una recepción acogedora, una amplia cafetería y una cómoda sala de estudiantes."}]}, {"title": "¿Qué preparación para exámenes ofrece el Colegio NED?", "body": [{"type": "p", "text": "Preparamos a nuestros estudiantes para diferentes tipos de pruebas de inglés: TIE, Trinity Integrated Skills in English, ISE, IELTS y Cambridge. El examen al final del curso es obligatorio para todos los estudiantes que requieren visa según las normas de GNIB y los costos están incluidos en la mayoría de nuestros paquetes. Recomendamos que consultes con tu agente para asegurarte de que esté incluido en el tuyo."}]}, {"title": "¿Qué es el examen TIE?", "body": [{"type": "p", "text": "El Test of Interactive English (TIE) es un examen internacional de inglés como lengua extranjera desarrollado en Irlanda por un grupo de profesionales irlandeses de enseñanza del inglés bajo el auspicio del Consejo Asesor de Escuelas de Inglés (ACELS), una agencia gubernamental que era responsable en ese momento de la garantía de calidad en la enseñanza del inglés. El TIE puede ser tomado por estudiantes juniors y adultos en cursos cortos o largos en Irlanda y en el extranjero. Para obtener más información: "}, {"type": "a", "link": "https://www.yesireland.ie/i-have-a-tie-exam-and-now/", "text": "https://www.yesireland.ie/i-have-a-tie-exam-and-now/"}]}, {"title": "¿Qué es un examen de Cambridge?", "body": [{"type": "p", "text": "Si has alcanzado un nivel de inglés más alto, esto significa que ahora estás más preparado para realizar exámenes de inglés más avanzados. Por eso, ofrecemos a nuestros estudiantes la oportunidad de evaluar sus habilidades mediante la realización de tres tipos diferentes de exámenes de Cambridge: PET, FCE y CAE. Para obtener más información sobre cada uno de ellos, haz clic aquí: "}, {"type": "a", "link": "https://www.yesireland.ie/cambridge-exams-pet-fce-and-cae-what-are-they/", "text": "https://www.yesireland.ie/cambridge-exams-pet-fce-and-cae-what-are-they/"}]}, {"title": "¿Debo asistir al 100% de las clases?", "body": [{"type": "p", "text": "Idealmente deberías hacerlo, sin embargo, pueden suceder muchos eventos inesperados, por lo que es poco probable que asistas al 100% de las clases. La tasa de asistencia mínima es del 85%. Debido a que es un requisito legal, debes tener en cuenta que no cumplir con una asistencia del 85% puede conducir a un rechazo en caso de que intentes renovar tu visa en la Oficina de Inmigración de Irlanda."}]}, {"title": "¿Puedo ser expulsado del Colegio NED?", "body": [{"type": "p", "text": "Sí. Si un estudiante no puede completar su curso con una asistencia del 85%, el Colegio NED se reserva el derecho de expulsar al estudiante sin emitir cuatro advertencias. La asistencia es un requisito de la visa de un estudiante y la falta de asistencia resultará en expulsión y puede resultar en la pérdida del permiso de estudio y trabajo de un estudiante en Irlanda. En nuestra comunidad, no toleramos ninguna forma de mala conducta y el incumplimiento de esto puede llevar a la expulsión. Para obtener más información, lee nuestra Política Escolar aquí: "}, {"type": "a", "link": "https://ned.ie/about_us/privacy_policy/", "text": "https://ned.ie/about_us/privacy_policy/"}]}, {"title": "Proceso de Apelación de Expulsión", "body": [{"type": "p", "text": "En cualquier etapa durante el proceso descrito anteriormente, los estudiantes son bienvenidos y se les anima a discutir cualquier problema que pueda estar contribuyendo a que no puedan cumplir con los requisitos de asistencia. La escuela tiene una política de puertas abiertas, personal disponible y varias opciones de comunicación abiertas para los estudiantes. Si durante el proceso descrito anteriormente, un estudiante;"}, {"type": "p", "text": "(A) No responde/interactúa/colabora con la escuela;"}, {"type": "p", "text": "(B) Continúa sin asistir a clase;"}, {"type": "p", "text": "(C) Si un estudiante no puede alcanzar una asistencia del 85% antes de que termine su',
      {
        title: "Vivir en Irlanda",
        items: [
          {
            title: "¿Dónde encontrar alojamiento permanente?",
            body: [
              {
                type: "p",
                text: "Debido a que Irlanda es un país bastante pequeño, encontrar alojamiento no debería ser difícil ya que el país está preparado para recibir estudiantes de todas partes. La ciudad de Dublín está dividida en 24 distritos postales diferentes: los números impares se encuentran en el lado norte del río Liffey, mientras que los números pares se encuentran en el lado sur. Limerick es la tercera ciudad más grande de la República de Irlanda y está situada en el centro-oeste de Irlanda, a orillas del río Shannon. Hay una variedad de vecindarios en Limerick donde puedes encontrar alojamiento, desde áreas para estudiantes hasta vecindarios residenciales más grandes.",
              },
            ],
          },
          {
            title: "¿Cuánto cuesta vivir en Irlanda?",
            body: [
              {
                type: "p",
                text: "Irlanda es una de las economías más importantes de Europa en la actualidad. Esto significa que aunque tengas que invertir un poco más de dinero para venir a estudiar aquí, el dinero ganado valdrá más que tu moneda actual.",
              },
            ],
          },
          {
            title: "¿Qué documentos necesito para trabajar en Irlanda?",
            body: [
              {
                type: "p",
                text: "Una vez que hayas solicitado y recibido tu Tarjeta de Residencia de Irlanda (IRP), necesitarás solicitar tu Número de PPS (Servicio Público Personal). Un número de PPS es un número de referencia único que te ayuda a acceder a beneficios de bienestar social, servicios públicos e información en Irlanda. Para solicitar un número de PPS, necesitas obtener una cita. Acceso:",
              },
              {
                type: "a",
                link: "http://www.citizensinformation.ie/en/social_welfare/irish_social_welfare_system/personal_public_service_number.html",
                text: "http://www.citizensinformation.ie/en/social_welfare/irish_social_welfare_system/personal_public_service_number.html",
              },
            ],
          },
          {
            title: "¿Cómo registro un trabajo con las autoridades?",
            body: [
              {
                type: "p",
                text: "Después de conseguir tu primer trabajo, necesitarás gestionar tus impuestos. Esto es muy importante mientras vives en Irlanda. Necesitas registrarte en el sitio web de Revenue: ",
              },
              {
                type: "a",
                link: "https://www.revenue.ie/en/Home.aspx",
                text: "https://www.revenue.ie/en/Home.aspx",
              },
            ],
          },
          {
            title:
              "¿Es fácil encontrar trabajo en Irlanda si mi nivel de inglés aún es principiante?",
            body: [
              {
                type: "p",
                text: "La economía irlandesa ha crecido enormemente en los últimos 10 años. Esto ha contribuido a aumentar la cantidad de empleos disponibles. En el sector de la hostelería, hay muchos empleos a tiempo parcial disponibles que muchos estudiantes pueden tomar. Debido a la alta demanda, podemos confirmar que es bastante fácil encontrar un trabajo en Irlanda, incluso si tu nivel de inglés es aún principiante. Además, trabajar es otra excelente manera de mejorar tus habilidades lingüísticas. Ofrecemos talleres gratuitos semanales de entrevistas y preparación de CV para ayudarte a conseguir un trabajo lo más rápido posible.",
              },
            ],
          },
          {
            title: "¿Qué tipo de trabajo suelen hacer los estudiantes en Irlanda?",
            body: [
              {
                type: "p",
                text: "Debido a que muchos estudiantes solo pueden trabajar a tiempo parcial, los tipos de trabajos que es más probable que tomen son en los sectores de venta minorista, hostelería y cuidado. Esto significa que hay muchas opciones como: asistente de deli, barista, asistente de ventas, bartender, au pair, niñera, limpiador/a, personal de piso, camarero/a, ayudante de cocina, etc.",
              },
            ],
          },
          {
            title: "¿Cuánto voy a ganar trabajando en Irlanda?",
            body: [
              {
                type: "p",
                text: "El salario mínimo en Irlanda es de €11.30 por hora. Esto significa que ninguna empresa puede pagarte menos. Sin embargo, dependiendo del trabajo que realices, el salario por hora puede ser mayor, como en el sector de la salud. Los cuidadores y las niñeras suelen recibir más de €12 por hora.",
              },
            ],
          },
        ],
      },
    ],
  },

  financial_plan: {
    title: `Da el primer paso con nuestra <span class="text-green3">Guía Completa de Planificación Financiera</span> para Estudiar en Irlanda`,
    welcome: {
      title: "¡Bienvenido a la Guía de Planificación Financiera para Estudiar en Irlanda!",
      subtitle:
        "¿Sueñas con hacer un intercambio en la Isla Esmeralda? Entonces, este libro electrónico es para ti.",
      text: "Sabemos que el aspecto financiero puede ser desafiante, por eso hemos creado una guía completa que te permitirá realizar tu sueño sin preocupaciones.",
    },
    why: {
      title: "¿Por qué debes descargar esta guía?",
      items: [
        {
          icon: "/landings/financial_plan/icon_1.png",
          text: 'Define tus <span class="text-green3">objetivos con el intercambio y entiende</span> los costos involucrados.',
        },
        {
          icon: "/landings/financial_plan/icon_2.png",
          text: 'Descubre cómo crear un <span class="text-green3">presupuesto personalizado</span> según tu realidad.',
        },
        {
          icon: "/landings/financial_plan/icon_3.png",
          text: 'Aprende cómo ahorrar y <span class="text-green3">administrar tu dinero</span> antes y durante el intercambio.',
        },
        {
          icon: "/landings/financial_plan/icon_4.png",
          text: 'Averigua cómo encontrar un <span class="text-green3">trabajo durante el intercambio</span> para ayudarte a cubrir tus gastos.',
        },
        {
          icon: "/landings/financial_plan/icon_5.png",
          text: 'Obtén consejos sobre cómo lidiar con <span class="text-green3">imprevistos y emergencias financieras</span> que puedan surgir.',
        },
      ],
    },
    cta: "¡Descarga aqui!",
    cta_title:
      '¡Descarga ahora la <span class="text-blue2">Guía de planificación financiera para estudiar en Irlanda</span> y empieza a hacer realidad tu sueño de intercambio!',
    footer: {
      campus: "Dublin & Limerick",
    },
    form: {
      title:
        "Complete el siguiente formulario para recibir el libro electrónico directamente en su correo electrónico",
      name: `Nombre completo`,
      email: `Correo electrónico`,
      whatsapp: `Phone number/WhatsApp`,
      nationality: `Seleccione su nacionalidad`,
      campus: `¿En qué campus quieres estudiar?`,
      mkt_source: `¿Cómo conociste nuestro eBook?`,
      button: `¡Descarga mi libro electrónico ahora!`,
    },
    ebook_thumb: "/landings/financial_plan/ebook-thumb-es.png",
  },
  financial_plan_thanks: {
    title: `¡Gracias por descargar la Guía de planificación financiera para estudiar en Irlanda!`,
    first_step: {
      title: "¡Ya has dado el primer paso para hacer realidad tu sueño de realizar un intercambio!",
      subtitle:
        "Aprovecha nuestros consejos y empieza a prepararte para vivir la mejor experiencia de tu vida.",
      bold: "¡Cuenta con nosotros para ayudarte en este viaje!",
    },
    socials: {
      title:
        "¡Sigue la vida diaria de nuestra escuela y descubre cómo son las vidas de nuestros estudiantes!",
      subtitle: "¡Síguenos en las redes sociales!",
    },
    footer: {
      campus: "Dublin & Limerick",
    },
    ebook_thumb: "/landings/financial_plan/ebook-thumb-es.png",
  },
  partnership: {
    topbar: "<b>Un <span class='text-green3'>nuevo viaje</span> está a punto de comenzar</b>",
    header: {
      title: "Bienvenido a nuestra <span class='text-green3'>área de asociación</span>",
      subtitle:
        "Aquí puedes encontrar todo sobre nosotros, incluyendo fotos, videos, folletos y más.",
    },
    about: {
      title: 'Acerca de <span class="text-blue2">nuestra escuela</span>',
      subtitle:
        "Somos una Escuela de Idioma Inglés ubicada en Irlanda desde 2011. Con sedes en Dublín y Limerick, hemos estado ayudando a estudiantes de todo el mundo a mejorar sus habilidades en inglés y conectarse con nuevas personas y experiencias.",
      text: "Nuestro dedicado equipo ha estado trabajando diligentemente para ofrecer lo mejor para nuestros estudiantes, yendo más allá de solo clases de inglés. Nuestro objetivo es ofrecer una experiencia inolvidable de estudiar en el extranjero. Para lograr esto, brindamos apoyo personalizado al estudiante, profesores altamente calificados y un entorno cultural inmersivo.",
    },
    accreditations: "Asociados <span class='text-blue2'>& Acreditaciones</span>",
    media: {
      title: "Biblioteca de <span class='text-green2'>Medios</span>",
      subtitle:
        "Aquí encontrarás información para conocernos mejor. Descubre detalles sobre nuestros campus, misión, cursos, niveles, vida estudiantil, información de visas, actividades extra y clases.",
      text: "Nuestro calendario incluye fechas de inicio de cursos, días festivos y fechas oficiales de exámenes. Y, por supuesto, podrás ver de cerca nuestra escuela a través de nuestras imágenes y videos.",
      items: [
        {
          title: "Folleto del Colegio NED",
          description:
            "Descarga aquí nuestro folleto digital, que incluye detalles sobre nuestros campus, misión, cursos, vida estudiantil, actividades extra y clases.",
          link: "#brochure",
        },
        {
          title: "Lista de Precios",
          description: "Descarga la lista de precios anual del Colegio NED 2023 / 2024",
          link: "#pricelist",
        },
        {
          title: "Calendario",
          description: "Descarga nuestro calendario 2024 para Dublín y Limerick",
          link: "#calendar",
        },
        {
          title: "Galería de Videos",
          description:
            "Descarga videos de alta calidad de nuestros campus, estudiantes, actividades y más",
          link: "#videogallery",
        },
        {
          title: "Galería de Imágenes",
          description:
            "Descarga imágenes de alta calidad de nuestros campus, estudiantes, actividades y más",
          link: "#imagegallery",
        },
        {
          title: "Material Gráfico",
          description: "Descarga nuestros logos y material gráfico",
          link: "#graphicmaterial",
        },
      ],
    },
    brochure: {
      title: "Folleto del Colegio NED",
      subtitle:
        "Descargue aquí nuestro folleto digital, que incluye detalles sobre nuestras sedes, misión, cursos, vida estudiantil y actividades y clases adicionales",
      items: [
        {
          title: "Versión en inglés",
          image: "brochure-en",
          link: "https://nedcollege-my.sharepoint.com/:b:/g/personal/anderson_ned_ie/EWme5bnmNOtMqXymLGwRyQQBs9YC938Zc_Y1ZypepuQv-Q?e=LyUUQV",
        },
        {
          title: "Versión en español",
          image: "brochure-es",
          link: "https://nedcollege-my.sharepoint.com/:b:/g/personal/anderson_ned_ie/EZUVnEk1BFROtqdDw4wq5lcBaDPXGUdZ-khAP09SUqHdmQ?e=gTx9lS",
        },
        {
          title: "Versión en portugués",
          image: "brochure-pt",
          link: "https://nedcollege-my.sharepoint.com/:b:/g/personal/anderson_ned_ie/EV95jhfHGhtBgEMYH_fQK6cBSuzRDRTHBax9cvYTdrrzaw?e=AIdF3L",
        },
        {
          title: "Versión en chino",
          image: "brochure-en",
          link: "https://nedcollege-my.sharepoint.com/:b:/g/personal/anderson_ned_ie/Eb-YCRFk3jdPtUF3cbO4ye0BMnIXbUcuGCu9_0WG_ZatgA?e=Jtc9Ou",
        },
        {
          title: "Versión en mongol",
          image: "brochure-mg",
          link: "https://nedcollege-my.sharepoint.com/:b:/g/personal/anderson_ned_ie/ESAgdnGY7H1Ei60cWc5_IW8BrkpiBiXulx9fu3tkSm4fTQ?e=cPpHsA",
        },
      ],
    },
    pricelist: {
      title: "Lista de precios",
      subtitle: "Descarga la lista de precios anual del NED College 2023 / 2024",
      items: [
        {
          title: "Lista de precios 2023 / 2024",
          image: "pricelist",
          link: "https://docs.google.com/presentation/d/e/2PACX-1vT8CHNyzX3jCOfTEKofimlXBiOZb7mHjfk1gu7Kp-pfYKxjK5MErzKMYIL4pOZMbvYEscT3s8Ciko8F/pub?start=false&loop=false&delayms=3000",
        },
      ],
    },
    calendar: {
      title: "Calendario",
      subtitle: "Descarga nuestro calendario 2024 para Dublín y Limerick",
      items: [
        {
          title: "Versión de Dublín y Limerick",
          image: "calendario",
          link: "https://nedcollege-my.sharepoint.com/:b:/g/personal/anderson_ned_ie/EUvJOgqHKBlKsgtKtIKEmlgBAzeJbBE6Ben6I7R6ZOOLEw?e=7zcxtQ",
        },
      ],
    },
    videos: {
      title: "Galería de Videos",
      subtitle:
        "Descarga videos de alta calidad de nuestros campus, estudiantes, actividades y más",
      items: [
        {
          title: "Institucional Dublín",
          image: "institutional-dublin",
          link: "https://nedcollege-my.sharepoint.com/:v:/g/personal/anderson_ned_ie/ET7zhcWRP9pPogf3nnF5d7YBB5U4F_6Z92KcUNdgPcVHRw?e=wbcbUT",
        },
        {
          title: "Institucional Limerick",
          image: "institutional-limerick",
          link: "https://nedcollege-my.sharepoint.com/:v:/g/personal/anderson_ned_ie/EUMgORzPrmVDvDKMwybnIBYBtO6wUCqmGURnenlLwlt_dA?e=HW7V8P&nav=eyJyZWZlcnJhbEluZm8iOnsicmVmZXJyYWxBcHAiOiJTdHJlYW1XZWJBcHAiLCJyZWZlcnJhbFZpZXciOiJTaGFyZURpYWxvZyIsInJlZmVycmFsQXBwUGxhdGZvcm0iOiJXZWIiLCJyZWZlcnJhbE1vZGUiOiJ2aWV3In19",
        },
        {
          title: "Eaquals 2023",
          image: "eaquals-2023",
          link: "https://nedcollege-my.sharepoint.com/:v:/g/personal/anderson_ned_ie/ETqnTHuHZ4pLtzrd0DSOk20BsU_X3hibBVdlUHJ3cJ1C1A?e=ISwNMi",
        },
        {
          title: "NED College 10 años",
          image: "ned-10-years",
          link: "https://nedcollege-my.sharepoint.com/:v:/g/personal/anderson_ned_ie/EadXawYqmcZCiDRveuslLoUBFxFPUWA5xz69agcCZ7feaQ?e=GNOL0g",
        },
        {
          title: "BeNED 2023",
          image: "bened-2023",
          link: "https://nedcollege-my.sharepoint.com/:v:/g/personal/anderson_ned_ie/EfdsWeUiEPlNgXDt7HNygDEB5zMstUNOMOxCey02qHwPMg?e=qn8TK4",
        },
      ],
    },
    images: {
      title: "Galería de imágenes",
      subtitle:
        "Descarga imágenes de alta calidad de nuestros campus, estudiantes, actividades y más",
      dublin: {
        title: "Campus de Dublín",
        link: "https://nedcollege-my.sharepoint.com/:f:/g/personal/anderson_ned_ie/Eho8B1G9ahRLtQf3B5bNoNMBqHBBB_6FdCf9Qr2PBkZtcA?e=BNYHez",
        items: [
          "gallery-dublin-1",
          "gallery-dublin-2",
          "gallery-dublin-3",
          "gallery-dublin-4",
          "gallery-dublin-5",
          "gallery-dublin-6",
          "gallery-dublin-7",
          "gallery-dublin-8",
          "gallery-dublin-9",
          "gallery-dublin-10",
          "gallery-dublin-11",
          "gallery-dublin-12",
          "gallery-dublin-13",
          "gallery-dublin-14",
        ],
      },
      limerick: {
        title: "Campus de Limerick",
        link: "https://nedcollege-my.sharepoint.com/:f:/g/personal/anderson_ned_ie/Eh__OO3JlBdPvJwEXCR2RDwBA66bishS4TNCPr1Nus8Zjw?e=FUKHU9",
        items: [
          "gallery-limerick-1",
          "gallery-limerick-2",
          "gallery-limerick-3",
          "gallery-limerick-4",
          "gallery-limerick-5",
          "gallery-limerick-6",
          "gallery-limerick-7",
          "gallery-limerick-8",
          "gallery-limerick-9",
        ],
      },
    },
    material: {
      title: "Material Gráfico",
      subtitle: "Descarga nuestros logotipos y material gráfico",
      items: [
        {
          title: "Versión Completa Principal",
          image: "graphic-mat-main-complete-version",
          link: "https://nedcollege-my.sharepoint.com/:f:/g/personal/anderson_ned_ie/Eq8zA9YJsGxAqmnPW-nUhicBzHI724v27zVppJX8Oo0x8Q?e=wV4PS1",
        },
        {
          title: "Versión Icono Principal",
          image: "graphic-mat-main-icon-version",
          link: "https://nedcollege-my.sharepoint.com/:f:/g/personal/anderson_ned_ie/EoymnbheQ4tIn0aYTrckceYBRV6YcgRff2hHe2fRHyI1gg?e=a6bKhR",
        },
        {
          title: "Versión Completa Secundaria",
          image: "graphic-mat-secondary-complete-version",
          link: "https://nedcollege-my.sharepoint.com/:f:/g/personal/anderson_ned_ie/EkGxlVnd5Y9EnsS6qOn163UBI0MTzns7NB7VdYI7T7z8ZA?e=HMMbJy",
        },
        {
          title: "Versión Icono Secundaria",
          image: "graphic-mat-secondary-icon-version",
          link: "https://nedcollege-my.sharepoint.com/:f:/g/personal/anderson_ned_ie/EnSpYoHSDNhKhIv9L5BwzyoB0esoGM9nk6J7hk7C5geirw?e=IUbmsz",
        },
        {
          title: "Directrices de Marca NED",
          image: "graphic-mat-brand-guidelines",
          link: "https://nedcollege-my.sharepoint.com/:b:/g/personal/anderson_ned_ie/EUrSJ4DVF-xIh1Y6TPKUCawBzTHX25c_m2bWFRN6lMGwJQ?e=yYUt58",
        },
      ],
    },
    footer: {
      title: "¡Queremos saber <span class='text-green2'>de ti!</span>",
      subtitle:
        "Si quieres colaborar con nosotros, no dudes en ponerte en contacto con nosotros. ¡Estamos deseando escuchar tus ideas!",
      button: "Contáctanos",
    },
    back_to_top: "Volver arriba",
  },
  thank_you: {
    title: "¡Gracias <span class='text-green3'>por ponerse en contacto!</span>",
    subtitle: "¡Nuestro equipo se pondrá en contacto con usted muy pronto!",
    card: {
      title: "Mientras tanto",
      body: "¿Por qué no saber más sobre nosotros, explorar nuestros campus de Dublín y Limerick o seguir nuestras redes sociales?",
    },
  },
  mapsection: {
    title1: "Apoyo a estudiantes en ",
    title2: "tu propio idioma",
    text: "En el Colegio NED, brindaremos apoyo a nuestros estudiantes antes de su llegada y durante su periodo de estudio en Irlanda. Se proporcionará toda la información sobre el curso, la visa, el alojamiento, el transporte público, el permiso de trabajo y cómo aprovechar al máximo tu experiencia en Dublín y Limerick.",
    button: "¡Habla con nuestros agentes!",
  },
  splitted_center: {
    title1: "Elegir",
    title2: "entre",
  },
  testimonialsection: {
    title: "Testimonios de estudiantes",
  },
  teamsection: {
    title: "Conoce a nuestro equipo de ventas",
    text1: "Campus / Oficinas",
    text2: "Encuentra a tu agente aquí",
    text3:
      "Nos enorgullece tener un equipo de ventas diverso y multicultural dedicado a ayudar a estudiantes de todo el mundo a venir y experimentar las increíbles oportunidades que Irlanda tiene para ofrecer. Ya sea que estés buscando mejorar tus habilidades en idiomas, explorar una nueva cultura o perseguir tus aspiraciones académicas o profesionales, nuestro equipo está aquí para brindarte apoyo en cada paso del camino.",
    locations: [
      {
        value: "dublin",
        label: "Campus en Dublin",
      },
      {
        value: "limerick",
        label: "Campus en Limerick",
      },
      {
        value: "chile",
        label: "Oficina en Chile",
      },
      {
        value: "uruguay",
        label: "Oficina en Uruguay",
      },
    ],
    team: [
      {
        image: "staff_22",
        name: "Alam Grace",
        subtitle: "Agente de Ventas Paraguay",
        flag: "paraguay",
        location: "dublin",
      },
      {
        image: "staff_default",
        name: "Amarsaikhan Batsambuu",
        subtitle: "Agente de Ventas Mongolia",
        flag: "mongolia",
        location: "dublin",
      },
      {
        image: "staff_default",
        name: "Daniela Peña",
        subtitle: "Agente de Ventas México",
        flag: "mexico",
        location: "dublin",
      },
      {
        image: "staff_default",
        name: "Beatriz Cassão",
        subtitle: "Agente de Ventas Brasil",
        flag: "brazil",
        location: "dublin",
      },
      {
        image: "staff_1",
        name: "Carolina Rojas",
        subtitle: "Agente de Ventas Costa Rica",
        flag: "costa_rica",
        location: "dublin",
      },
      {
        image: "staff_3",
        name: "Deniz Imark",
        subtitle: "Agente de Ventas Turquía",
        flag: "turkey",
        location: "dublin",
      },
      {
        image: "staff_17",
        name: "Dhiogo Lunardelli",
        subtitle: "Agente de Ventas Brasil",
        flag: "brazil",
        location: "dublin",
      },
      {
        image: "staff_13",
        name: "Irina Nikicink",
        subtitle: "Agente de Ventas Paraguay",
        flag: "paraguay",
        location: "dublin",
      },
      {
        image: "staff_19",
        name: "Larissa Rossi Samuel",
        subtitle: "Agente de Ventas Brasil",
        flag: "brazil",
        location: "dublin",
      },
      {
        image: "staff_18",
        name: "Marina Contreras",
        subtitle: "Agente de Ventas Chile",
        flag: "chile",
        location: "dublin",
      },
      {
        image: "staff_15",
        name: "Mayra Weber",
        subtitle: "Agente de Ventas Brasil",
        flag: "brazil",
        location: "dublin",
      },
      {
        image: "staff_14",
        name: "Otavio Damaceno",
        subtitle: "Agente de Ventas Brasil",
        flag: "brazil",
        location: "dublin",
      },
      {
        image: "staff_default",
        name: "Otavio Magdaleno",
        subtitle: "Agente de Ventas Brasil",
        flag: "brazil",
        location: "dublin",
      },
      {
        image: "staff_12",
        name: "Tserenlkham Agi",
        subtitle: "Agente de Ventas Mongolia",
        flag: "mongolia",
        location: "dublin",
      },
      {
        image: "staff_16",
        name: "Vitor Britto",
        subtitle: "Agente de Ventas Brasil",
        flag: "brazil",
        location: "dublin",
      },
      {
        image: "staff_10",
        name: "Camila Vogel",
        subtitle: "Agente de Ventas Brasil",
        flag: "brazil",
        location: "limerick",
      },
      {
        image: "staff_default",
        name: "Chong Rong",
        subtitle: "Agente de Ventas Malasia",
        flag: "malaysia",
        location: "limerick",
      },
      {
        image: "staff_6",
        name: "Erik Beltrane",
        subtitle: "Agente de Ventas Chile",
        flag: "chile",
        location: "limerick",
      },
      {
        image: "staff_11",
        name: "Gabriela Iramendi",
        subtitle: "Agente de Ventas Brasil",
        flag: "brazil",
        location: "limerick",
      },
      {
        image: "staff_default",
        name: "Matheus de Oliveira",
        subtitle: "Agente de Ventas Brasil",
        flag: "brazil",
        location: "limerick",
      },
      {
        image: "staff_5",
        name: "Melissa Avila",
        subtitle: "Agente de Ventas Costa Rica",
        flag: "costa_rica",
        location: "limerick",
      },
      {
        image: "staff_default",
        name: "Rhayane Caldeira",
        subtitle: "Agente de Ventas Brasil",
        flag: "brazil",
        location: "limerick",
      },
      {
        image: "staff_7",
        name: "Tiago Wagner",
        subtitle: "Agente de Ventas Brasil",
        flag: "brazil",
        location: "limerick",
      },
      {
        image: "staff_default",
        name: "Waldo Ramos",
        subtitle: "Agente de Ventas Chile",
        flag: "chile",
        location: "limerick",
      },
      {
        image: "staff_default",
        name: "Constanza Del Río",
        subtitle: "Agente de Ventas Chile",
        flag: "chile",
        location: "chile",
      },
      {
        image: "staff_default",
        name: "Daniela Henríquez",
        subtitle: "Agente de Ventas Chile",
        flag: "chile",
        location: "chile",
      },
      {
        image: "staff_default",
        name: "Cristal Perez",
        subtitle: "Agente de Ventas Chile",
        flag: "chile",
        location: "chile",
      },
      {
        image: "staff_2",
        name: "Florencia Hidalgo",
        subtitle: "Agente de Ventas Chile",
        flag: "chile",
        location: "chile",
      },
      {
        image: "staff_4",
        name: "Eduardo Fernández",
        subtitle: "Agente de Ventas Chile",
        flag: "chile",
        location: "chile",
      },
      {
        image: "staff_default",
        name: "Natalia Smith",
        subtitle: "Agente de Ventas Uruguay",
        flag: "uruguay",
        location: "uruguay",
      },
      {
        image: "staff_25",
        name: "Paula Piriz",
        subtitle: "Agente de Ventas Uruguay",
        flag: "uruguay",
        location: "uruguay",
      },
      {
        image: "staff_23",
        name: "Manuela Amato",
        subtitle: "Agente de Ventas Uruguay",
        flag: "uruguay",
        location: "uruguay",
      },
      {
        image: "staff_default",
        name: "Anudari Erdenetsogt",
        subtitle: "Agente de Ventas Mongolia",
        flag: "mongolia",
        location: "dublin",
      },
      {
        image: "staff_default",
        name: "Charles Michael Osowski",
        subtitle: "Agente de Ventas Brasil",
        flag: "brazil",
        location: "limerick",
      },
      {
        image: "staff_default",
        name: "Francine Mendez",
        subtitle: "Agente de Ventas Costa Rica",
        flag: "costa_rica",
        location: "limerick",
      },
      {
        image: "staff_default",
        name: "Germano Santana",
        subtitle: "Agente de Ventas Brasil",
        flag: "brazil",
        location: "dublin",
      },
      {
        image: "staff_default",
        name: "Ho Li Peng",
        subtitle: "Agente de Ventas Malasia",
        flag: "malaysia",
        location: "Limerick",
      },
      {
        image: "staff_default",
        name: "Ingryd Lima",
        subtitle: "Agente de Ventas Brasil",
        flag: "brazil",
        location: "dublin",
      },
      {
        image: "staff_default",
        name: "Les Monárdez",
        subtitle: "Agente de Ventas Chile",
        flag: "chile",
        location: "chile",
      },
      {
        image: "staff_default",
        name: "Manuela mardones",
        subtitle: "Agente de Ventas Chile",
        flag: "chile",
        location: "chile",
      },
      {
        image: "staff_default",
        name: "Marcos Souza",
        subtitle: "Agente de Ventas Brasil",
        flag: "brazil",
        location: "limerick",
      },
      {
        image: "staff_default",
        name: "Melissa Rojas",
        subtitle: "Agente de Ventas Costa Rica",
        flag: "costa_rica",
        location: "dublin",
      },
      {
        image: "staff_default",
        name: "Tiffany Chong Nyet Jun",
        subtitle: "Agente de Ventas Malasia",
        flag: "malaysia",
        location: "dublin",
      },
      {
        image: "staff_default",
        name: "Wee Yee Lau",
        subtitle: "Agente de Ventas Malasia",
        flag: "malaysia",
        location: "dublin",
      },
    ],
  },
  topbar: {
    button: "¡Obtener una cotización!",
    icon: "ES",
  },
  contactform: {
    name: "Tu nombre completo",
    address: "Tu dirección de correo electrónico",
    phone: "Tu número de teléfono",
    label1: "Seleccione su nacionalidad",
    label2: "Seleccione el país en el que actualmente vive",
    label3:
      "¿En qué fase se encuentra en la planificación de sus estudios de inglés en el extranjero?",
    label5: "Seleccione el programa que está buscando",
    label4: "¿En qué campus desea estudiar?",
    message: "Si quieres escribir algo, siéntete libre de hacerlo",
    steps: [
      {
        value: "Solo investigando y tratando de entender sobre estudiar en el extranjero",
        label: "Solo investigando y tratando de entender sobre estudiar en el extranjero",
      },
      {
        value: "Sé cuánto puedo invertir, pero no sé el destino y/o la escuela",
        label: "Sé cuánto puedo invertir, pero no sé el destino y/o la escuela",
      },
      {
        value: "Preparado financieramente y decidiendo en qué escuela estudiar",
        label: "Preparado financieramente y decidiendo en qué escuela estudiar",
      },
    ],
    campuses: [
      {
        value: "dublin",
        label: "Campus de Dublín",
      },
      {
        value: "limerick",
        label: "Campus de Limerick",
      },
      {
        value: "didnt_decide",
        label: "Todavía no he decidido",
      },
    ],
    programmes: [
      {
        value: "first_general",
        label: "Primer curso - Inglés general",
      },
      {
        value: "first_ielts",
        label: "Primer curso - Curso de preparación para el examen IELTS",
      },
      {
        value: "ren_general",
        label: "Renovación - Curso de Inglés general",
      },
      {
        value: "ren_ielts",
        label: "Renovación - Curso de preparación para el examen IELTS",
      },
    ],
    button: "¡Enviar!",
    success_msg: "¡Gracias, tu mensaje ha sido enviado!",
  },
  english_test: {
    title: "Prueba tu Inglés",
    breadcr: ["Prueba tu Inglés"],
    subtitle: "Prueba de Nivel Online",
    description: "Evalúa tu nivel de inglés con nuestra prueba de nivel gratuita en línea. Esto nos ayudará a determinar tu nivel actual y recomendarte el curso más adecuado para ti.",
    form_title: "Por favor, completa el formulario a continuación para comenzar tu prueba.",
    form_fields: {
      name: "Nombre Completo",
      email: "Correo Electrónico",
      phone: "Número de Teléfono",
      country: "País",
      nationality: "Nacionalidad",
      course: "Curso de Interés",
      select_country: "Selecciona tu país",
      select_nationality: "Selecciona tu nacionalidad",
      select_course: "Selecciona un curso",
      submit_button: "Comenzar la Prueba"
    },
    test_title: "Prueba de Nivel de Inglés",
    test_description: "Responde las siguientes preguntas para ayudarnos a evaluar tu nivel de inglés.",
    test_completed_title: "¡Prueba Completada!",
    test_completed_message: "Gracias por completar nuestra prueba de nivel de inglés. Nuestro equipo revisará tus resultados y se pondrá en contacto contigo pronto con recomendaciones de cursos adaptados a tu nivel de competencia.",
    return_home: "Volver a la Página Principal"
  },
  footer: {
    title: "Descarga nuestro folleto",
    text: "¡Descubre todo sobre estudiar en Irlanda con el Colegio NED!",
    button: "Descargar ahora",
    ireland: "República de Irlanda",
    download_d: "Descarga nuestra APP de Dublín",
    download_l: "Descarga nuestra APP de Limerick",
    opening: "Horario de apertura",
    days: "Lunes a viernes",
    days1: "de 9:00 a 16:30",
    email: "Email",
    refund: "Nota de crédito y solicitud de reembolso",
    terms: "Términos y condiciones",
    privacy: "Política de privacidad",
    download: "Descarga nuestro folleto",
    subtitlemodal: "¡Descubre todo sobre estudiar en Irlanda con el Colegio NED!",
  },
};
